<template>
    <Alert v-for="(a, index) in alert" :key="a" :data="a" @closeAlert="closeAlert(index)"/>
    <TopNavigation title="" hideSecondNavbar="true" />  
    <div id="home"></div>

    <!-- <div class="row bg-warning mt-5 mb-2">
        <img src="../assets/home/main4.png" alt="main" style="width: 100%; object-fit: cover;">
    </div> -->
    <!-- Carousel -->
    <div class="row" style="margin-top: 30px;">
        <div id="mainSlider" class="carousel slide px-0" data-bs-ride="carousel" data-bs-pause="hover" >

            <!-- Indicators/dots -->
            <div class="carousel-indicators">
                <button type="button" data-bs-target="#mainSlider" data-bs-slide-to="0" class="active"></button>
                <button type="button" data-bs-target="#mainSlider" data-bs-slide-to="1"></button>
                <button type="button" data-bs-target="#mainSlider" data-bs-slide-to="2"></button>
                <button type="button" data-bs-target="#mainSlider" data-bs-slide-to="3"></button>
            </div>

            <!-- The slideshow/carousel -->
            <div class="carousel-inner">
                <div class="carousel-item active text-center">
                    <div class="container-fluid p-0">
                        <picture>
                            <source media="(min-width: 992px)" srcset="@/assets/home/main_large.webp">
                            <img src="@/assets/home/main_small.webp" alt="SignOn homepage" fetchpriority="high"
                                style="width: 100%; object-fit: cover">
                        </picture>
                        <!-- <img src="../assets/home/main_large.png" alt="main" class="d-none d-lg-block" style="width: 100%; object-fit: cover;">
                        <img src="../assets/home/main_small.png" alt="main" class="d-lg-none" style="width: 100%; object-fit: cover"> -->
                        <h3 class="main-title" bg-red style="text-shadow: 0 2px 8px rgba(0,0,0,0.5);">Streamline Your Document Workflow</h3>
                        <p class="main-desc" style="text-shadow: 0 1px 4px rgba(0,0,0,0.4);">
                            SignOn offers a secure and efficient way to manage and sign documents online.<br />Simplify your processes and save time with our intuitive platform.
                        </p>
                        
                        <div class="d-none d-lg-block main-btn">
                            <button class="btn btn-info text-white btn-lg me-4" @click="goTrial" style="width: 200px;">Free Trial</button>
                            <button class="btn btn-outline-info btn-lg btnVerify" @click="goVerifyDoc" style="width: 200px;">
                                <fa :icon="['fas', 'fingerprint']" class="me-2"/>Validate
                            </button>
                        </div>
                        <!-- Small screen -->
                        <div class="d-lg-none main-btn">
                            <button class="btn btn-info text-white btn-lg me-4" @click="goTrial" style="width: 150px;">Free Trial</button>
                            <button class="btn btn-outline-info btn-lg btnVerify" @click="goVerifyDoc" style="width: 150px;">
                                <fa :icon="['fas', 'fingerprint']" class="me-2"/>Validate
                            </button>
                        </div>
                    </div>
                </div>
                <div class="carousel-item">
                    <div class="container-fluid p-0">
                        <picture>
                            <source media="(min-width: 992px)" srcset="@/assets/home/write_large.webp">
                            <img src="@/assets/home/write_small.webp" fetchpriority="high" decoding="async" style="width: 100%; object-fit: cover">
                        </picture>
                        <!-- <img src="../assets/home/write_large.png" alt="main" class="d-none d-lg-block" style="width: 100%; object-fit: cover;">
                        <img src="../assets/home/write_small.png" alt="main" class="d-lg-none" style="width: 100%; object-fit: cover"> -->
                        <h3 class="main-title" bg-red style="text-shadow: 0 2px 8px rgba(0,0,0,0.5);">Data Protection</h3>
                        <p class="main-desc" style="text-shadow: 0 1px 4px rgba(0,0,0,0.4);">Your data is protected with industry-leading security measures, ensuring confidentiality and integrity.</p>
                        
                        <div class="d-none d-lg-block main-btn">
                            <button class="btn btn-info text-white btn-lg me-4" @click="goTrial" style="width: 200px;">Free Trial</button>
                            <button class="btn btn-outline-info btn-lg btnVerify" @click="goVerifyDoc" style="width: 200px;">
                                <fa :icon="['fas', 'fingerprint']" class="me-2"/>Validate
                            </button>
                        </div>
                        <!-- Small screen -->
                        <div class="d-lg-none main-btn">
                            <button class="btn btn-info text-white btn-lg me-4" @click="goTrial" style="width: 150px;">Free Trial</button>
                            <button class="btn btn-outline-info btn-lg btnVerify" @click="goVerifyDoc" style="width: 150px;">
                                <fa :icon="['fas', 'fingerprint']" class="me-2"/>Validate
                            </button>
                        </div>
                    </div>
                </div>
                <div class="carousel-item">
                    <div class="container-fluid p-0">
                        <picture>
                            <source media="(min-width: 992px)" srcset="@/assets/home/watch_tab_large.webp">
                            <img src="@/assets/home/watch_tab_small.webp" fetchpriority="high" decoding="async" style="width: 100%; object-fit: cover">
                        </picture>
                        <!-- <img src="../assets/home/watch_tab_large.png" alt="main" class="d-none d-lg-block" style="width: 100%; object-fit: cover;">
                        <img src="../assets/home/watch_tab_small.png" alt="main" class="d-lg-none" style="width: 100%; object-fit: cover"> -->
                        <h3 class="main-title" bg-red style="text-shadow: 0 2px 8px rgba(0,0,0,0.5);">Track & Manage</h3>
                        <p class="main-desc" style="text-shadow: 0 1px 4px rgba(0,0,0,0.4);">Track the progress of your documents and manage them securely within your SignOn account.</p>
                        
                        <div class="d-none d-lg-block main-btn">
                            <button class="btn btn-info text-white btn-lg me-4" @click="goTrial" style="width: 200px;">Free Trial</button>
                            <button class="btn btn-outline-info btn-lg btnVerify" @click="goVerifyDoc" style="width: 200px;">
                                <fa :icon="['fas', 'fingerprint']" class="me-2"/>Validate
                            </button>
                        </div>
                        <!-- Small screen -->
                        <div class="d-lg-none main-btn">
                            <button class="btn btn-info text-white btn-lg me-4" @click="goTrial" style="width: 150px;">Free Trial</button>
                            <button class="btn btn-outline-info btn-lg btnVerify" @click="goVerifyDoc" style="width: 150px;">
                                <fa :icon="['fas', 'fingerprint']" class="me-2"/>Validate
                            </button>
                        </div>
                    </div>
                </div>
                <div class="carousel-item">
                    <div class="container-fluid p-0">
                        <picture>
                            <source media="(min-width: 992px)" srcset="@/assets/home/era_device_large.webp">
                            <img src="@/assets/home/era_device_small.webp" alt="main" fetchpriority="high" decoding="async" style="width: 100%; object-fit: cover">
                        </picture>
                        <!-- <img src="../assets/home/era_device_large.png" alt="main" class="d-none d-lg-block" style="width: 100%; object-fit: cover;">
                        <img src="../assets/home/era_device_small.png" alt="main" class="d-lg-none" style="width: 100%; object-fit: cover"> -->
                        <h3 class="main-title" bg-red style="text-shadow: 0 2px 8px rgba(0,0,0,0.5);">Sign Documents Anywhere, Anytime</h3>
                        <p class="main-desc" style="text-shadow: 0 1px 4px rgba(0,0,0,0.4);">
                            Experience seamless, secure, and affordable digital signing with SignOn.<br />Upload, assign, invite, sign, and seal your documents—anywhere, anytime.
                        </p>
                        
                        <div class="d-none d-lg-block main-btn">
                            <button class="btn btn-info text-white btn-lg me-4" @click="goTrial" style="width: 200px;">Free Trial</button>
                            <button class="btn btn-outline-info btn-lg btnVerify" @click="goVerifyDoc" style="width: 200px;">
                                <fa :icon="['fas', 'fingerprint']" class="me-2"/>Validate
                            </button>
                        </div>
                        <!-- Small screen -->
                        <div class="d-lg-none main-btn">
                            <button class="btn btn-info text-white btn-lg me-4" @click="goTrial" style="width: 150px;">Free Trial</button>
                            <button class="btn btn-outline-info btn-lg btnVerify" @click="goVerifyDoc" style="width: 150px;">
                                <fa :icon="['fas', 'fingerprint']" class="me-2"/>Validate
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Left and right controls/icons -->
            <button class="carousel-control-prev" type="button" data-bs-target="#mainSlider" data-bs-slide="prev">
                <span class="carousel-control-prev-icon"></span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#mainSlider" data-bs-slide="next">
                <span class="carousel-control-next-icon"></span>
            </button>
        </div>
    </div>
    <!-- End Carousel -->

    <div id="secHowItWork"></div>
    <div class="homeContainer">

        <!-- new start -->
        <div class="row mx-4">
            <div class="col-12 text-center secTitleNarrow">How it works</div>
        </div>

        <div class="row">
            <div class="col-12 lblStepSubDesc mb-3">SignOn is the only eSignature platform designed for seamless document management.</div>
        </div>

        <div class="row pt-0 mb-4">
            <div class="col-md-6 col-lg-3 p-3 d-grid">
                <div class="howBox border shadow-sm">
                    <div class="howBoxImgSec">
                        <fa :icon="['fas', 'upload']" style="font-size: 32px"/>
                    </div>
                    <div class="text-center">
                        <div class="howTitle">Upload</div>
                        <div class="lblStepSubDesc">Upload your document securely to SignOn.</div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-3 p-3 d-grid">
                <div class="howBox border shadow-sm">
                    <div class="howBoxImgSec">
                        <fa icon="user" style="font-size: 32px"/>
                    </div>
                    <div class="text-center">
                        <div class="howTitle">+ Signee</div>
                        <div class="lblStepSubDesc">Designate who needs to sign or view the document.</div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-3 p-3 d-grid">
                <div class="howBox border shadow-sm">
                    <div class="howBoxImgSec">
                        <fa icon="envelope" style="font-size: 32px"/>
                    </div>
                    <div class="text-center">
                        <div class="howTitle">Invite</div>
                        <div class="lblStepSubDesc">Send invitations to signees via email.</div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-3 p-3 d-grid">
                <div class="howBox border shadow-sm">
                    <div class="howBoxImgSec">
                        <fa icon="stamp" style="font-size: 32px"/>
                    </div>
                    <div class="text-center">
                        <div class="howTitle">Seal</div>
                        <div class="lblStepSubDesc">Seal the folder adter all documents are signed.</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 lblStepSubDesc">
                <div class="mb-3">Sign, securely seal folders for safekeeping, and shred documents with approval from all signees. Need additional signatures? Simply unseal and update with ease. </div>
                <div class="mb-3">Built for teams and collaborators, SignOn ensures efficiency while staying free online. Experience signing made smarter.</div>
            </div>
            <div class="col-12 mb-4 d-none d-md-block"><br></div>
        </div>

        <!-- <div class="row">
            <div class="row justify-content-center">
                <div class="col-12 whyTitle text-center mb-3">Got 1 minute?</div>
                <div class="col-12 lblStepSubDesc text-center mb-4">No fluff. No long tutorials. Just a 1-minute breakdown of exactly what you get.</div>
                <div class="col-12 col-md-10 col-lg-6">
                    <div class="ratio ratio-16x9">
                        <iframe 
                            src="https://www.youtube.com/embed/l75XejktCWY?si=XjDHVdRLIswz_zq-" 
                            title="SignOn - How it works" 
                            loading="lazy" 
                            frameborder="0" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                            referrerpolicy="strict-origin-when-cross-origin" 
                            allowfullscreen>
                        </iframe>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- Lazy loading for video -->
        <section class="row justify-content-center video-showcase" aria-labelledby="video-showcase-title">
            <div class="col-12 whyTitle text-center mb-2" id="video-showcase-title">Got 1 minute?</div>
            <div class="col-12 col-lg-8 lblStepSubDesc text-center mb-4">No fluff. No long tutorials. Just a 1-minute breakdown of exactly what you get.</div>
            <div class="col-12 col-md-10 col-lg-7">
                <div class="video-card">
                    <div class="ratio ratio-16x9 video-card__frame">
                        <iframe
                            src="https://www.youtube.com/embed/l75XejktCWY?si=XjDHVdRLIswz_zq-"
                            title="SignOn - How it works"
                            loading="lazy"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerpolicy="strict-origin-when-cross-origin"
                            allowfullscreen>
                        </iframe>
                    </div>
                </div>
            </div>
        </section>

        <!-- <div class="d-flex flex-wrap justify-content-center mb-5">
            <div class="howBoxContainer d-grid">
                <div class="howBox border shadow-sm">
                    <div class="howBoxImgSec">
                        <fa :icon="['fas', 'upload']" style="font-size: 32px"/>
                    </div>
                    <div class="text-center">
                        <div class="howTitle">Upload</div>
                        <div class="lblStepSubDesc">Upload your document securely to SignOn.</div>
                    </div>
                </div>
            </div>

            <div class="howBoxContainer d-grid">
                <div class="howBox border shadow-sm">
                    <div class="howBoxImgSec">
                        <fa icon="user" style="font-size: 32px"/>
                    </div>
                    <div class="text-center">
                        <div class="howTitle">+ Signee</div>
                        <div class="lblStepSubDesc">Designate who needs to sign or view the document.</div>
                    </div>
                </div>
            </div>

            <div class="howBoxContainer d-grid">
                <div class="howBox border shadow-sm">
                    <div class="howBoxImgSec">
                        <fa icon="envelope" style="font-size: 32px"/>
                    </div>
                    <div class="text-center">
                        <div class="howTitle">Invite</div>
                        <div class="lblStepSubDesc">Send invitations to signees via email.</div>
                    </div>
                </div>
            </div>

            <div class="howBoxContainer d-grid">
                <div class="howBox border shadow-sm">
                    <div class="howBoxImgSec">
                        <fa icon="pen" style="font-size: 32px"/>
                    </div>
                    <div class="text-center">
                        <div class="howTitle">Sign</div>
                        <div class="lblStepSubDesc">Sign the document digitally from any device.</div>
                    </div>
                </div>
            </div>

            <div class="howBoxContainer d-grid">
                <div class="howBox border shadow-sm">
                    <div class="howBoxImgSec">
                        <fa icon="stamp" style="font-size: 32px"/>
                    </div>
                    <div class="text-center">
                        <div class="howTitle">Seal</div>
                        <div class="lblStepSubDesc">Seal the document with a unique digital fingerprint.</div>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- new end -->

    </div>

    <!-- Enerson requested to hide tmp
    <div class="homeContainer">
        <div class="row">
            <div class="col-12 text-center secTitle">How to use</div>

            <div class="col-12 col-lg-6 d-grid">
                <div class="homeBox">
                    <div class="row">
                        <div class="col-12 col-lg-7 pb-4">
                            <div class="lblStep">STEP 1</div>
                            <div class="lblStepTitle">Upload</div>
                            <div class="lblStepDesc">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Rerum minima facere nulla officiis labore atque nisi necessitatibus, quidem cumque deleniti aut accusantium dolorum, ipsum fugiat, corporis tempora cupiditate nihil molestias.</div>
                        </div>
                        <div class="col-12 col-lg-5 pb-2">
                            <table height="100%" border="0" align="center">
                                <tr>
                                    <td class="align-bottom"><img alt="Vue logo" src="../assets/home/upload.jpg" style="border-radius: 10px; height: 155px; width: 155px; object-fit:cover"></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-6 d-grid">
                <div class="homeBox">
                    <div class="row">
                        <div class="col-12 col-lg-7 pb-4">
                            <div class="lblStep">STEP 2</div>
                            <div class="lblStepTitle">Design</div>
                            <div class="lblStepDesc">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Rerum minima facere nulla officiis labore atque nisi necessitatibus, quidem cumque cupiditate nihil molestias.</div>
                        </div>
                        <div class="col-12 col-lg-5 pb-2">
                            <table height="100%" border="0" align="center">
                                <tr>
                                    <td class="align-bottom"><img alt="Vue logo" src="../assets/home/edit1.jpg" style="border-radius: 10px; height: 155px; width: 155px; object-fit:cover"></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-6 d-grid">
                <div class="homeBox">
                    <div class="row">
                        <div class="col-12 col-lg-7 pb-4">
                            <div class="lblStep">STEP 3</div>
                            <div class="lblStepTitle">Invite</div>
                            <div class="lblStepDesc">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Rerum minima cumque deleniti aut accusantium dolorum, ipsum fugiat, corporis tempora cupiditate nihil molestias.</div>
                        </div>
                        <div class="col-12 col-lg-5 pb-2">
                            <table height="100%" border="0" align="center">
                                <tr>
                                    <td class="align-bottom"><img alt="Vue logo" src="../assets/home/send_email.jpg" style="border-radius: 10px; height: 155px; width: 155px; object-fit:cover"></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-6 d-grid">
                <div class="homeBox">
                    <div class="row">
                        <div class="col-12 col-lg-7 pb-4">
                            <div class="lblStep">STEP 4</div>
                            <div class="lblStepTitle">Sign</div>
                            <div class="lblStepDesc">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Rerum minima facere nulla  atque nisi necessitatibus, quidem cumque deleniti aut accusantium dolorum, ipsum fugiat, corporis tempora cupiditate nihil molestias.</div>
                        </div>
                        <div class="col-12 col-lg-5 pb-2">
                            <table height="100%" border="0" align="center">
                                <tr>
                                    <td class="align-bottom"><img alt="Vue logo" src="../assets/home/digital_signature.jpg" style="border-radius: 10px; height: 155px; width: 155px; object-fit:cover"></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
           
        </div>
    </div> -->

    <!-- Enerson requested to hide tmp
    <div class="homeContainer">
        <div class="row">
            <div class="col-12 text-center secTitle">How we protect your doc</div>

            <div class="col-12 col-lg-6 d-grid">
                <div class="homeBlueBox border shadow-sm">
                    <div class="boxTitle text-white">Decentralize documents</div>
                    <div class="boxDesc text-white">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Incidunt, illum possimus iusto ullam amet eligendi consequuntur, fuga reprehenderit molestias nostrum repellendus placeat. Temporibus error incidunt, sequi velit voluptatem ipsam nam.</div>
                    <div class="boxButton">
                        <button class="btn btn-light btn-lg btn-block mb-4" style="color: #53BDEB">Learn more</button>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-6 d-grid">
                <div class="homeBox border shadow-sm">
                    <div class="boxTitle">Encrypted documents</div>
                    <div class="boxDesc">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Incidunt, illum possimus iusto ullam amet eligendi consequuntur, fuga reprehenderit molestias nostrum repellendus placeat. Temporibus error incidunt, sequi velit voluptatem ipsam nam.</div>
                    <div class="boxButton">
                        <button class="btn btn-secondary btn-lg btn-block mb-4">Learn more</button>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <div id="secWhySignOn"></div>
    <div class="row">
        <div class="greyContainer">
            
            <div class="row">
                <div class="col-12 text-center secTitleNarrow">Why SignOn</div>
                <div class="col-12 mb-3">
                    <div class="greyContent">
                        <div class="row">
                            <div class="col-12 lblStepSubDesc mb-3">
                                Many do not understand the difference of eSignature and "Picture Signature". While eSignature has legal binding status in many countries, it is not the same for picture signature, which can be forged easily without verification, tracing and tracking.
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-6 col-lg-4 p-3 d-grid">
                                <div class="whyBox border shadow-sm">
                                    <table>
                                        <tr>
                                            <td class="align-middle pe-1"><fa :icon="['fas', 'fingerprint']" class="fs-1"/></td>
                                            <td class="whyTitle">Tamper-Proof Digital Fingerprint</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2" class="pt-2 text-grey">
                                                Every document is secured with a unique, verifiable fingerprint, ensuring authenticity and trust.
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4 p-3 d-grid">
                                <div class="whyBox border shadow-sm">
                                    <table>
                                        <tr>
                                            <td class="align-middle pe-1"><fa icon="lock" class="fs-1"/></td>
                                            <td class="whyTitle">Advanced Secure E-Signatures</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2" class="pt-2 text-grey">
                                                Sign with confidence—our legally binding e-signatures come with cutting-edge security features for maximum protection and compliance.
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4 p-3 d-grid">
                                <div class="whyBox border shadow-sm">
                                    <table>
                                        <tr>
                                            <td class="align-middle pe-1"><fa icon="signature" class="fs-1"/></td>
                                            <td class="whyTitle">Seamless Real-World Signing Experience</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2" class="pt-2 text-grey">
                                                Just like signing on paper! Sign, seal, request an unseal, and re-sign at different stages—previous signatures remain intact for complete transparency.
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4 p-3 d-grid">
                                <div class="whyBox border shadow-sm">
                                    <table>
                                        <tr>
                                            <td class="py-2 align-middle pe-1"><fa :icon="['fas','bolt']" class="fs-1"/></td>
                                            <td class="whyTitle">Instant Online Validation</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2" class="pt-2 text-grey">
                                                One-click verification lets you trace full audit logs and download original documents effortlessly.
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4 p-3 d-grid">
                                <div class="whyBox border shadow-sm">
                                    <table>
                                        <tr>
                                            <td class="align-middle pe-1"><fa :icon="['fas', 'mobile-screen-button']" class="fs-1"/></td>
                                            <td class="whyTitle">Universal Multi-Platform Access</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2" class="pt-2 text-grey">
                                                Enjoy seamless functionality across desktops, laptops, tablets, and mobile devices—wherever you need it.
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4 p-3 d-grid">
                                <div class="whyBox border shadow-sm">
                                    <table>
                                        <tr>
                                            <td class="align-middle pe-1"><fa :icon="['fas', 'gift']" class="fs-1"/></td>
                                            <td class="whyTitle">Free & Fair Usage for Everyone</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2" class="pt-2 text-grey">
                                                No cost to sign and invite others—enjoy a fully accessible e-signing experience within fair usage limits.
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 mb-3">
                                eSignatures are legal, trusted and enforceable in many countries around the world. The usage was boosted during Covid19 Pandemic around year 2021 as many businesses continued to operate as usual but the country was being locked down. Many people were forced to work from home (WFH), some of them started to use eSignature to sign agreements, contracts and forms online.
                            </div>
                        </div>

                        <div v-if="showMoreWhy === false" class="col-12 text-end">
                            <span class="text-info isLink" @click="showMoreWhy = !showMoreWhy">More</span>
                        </div>

                        <div v-if="showMoreWhy === true" class="row">
                            <!-- <div class="col-12 my-3">Many do not understand the difference of eSignature and "Picture Signature". While eSignature has legal binding status in many countries, it is not the same for picture signature, which can be forged easily without verification, tracing and tracking.</div> -->
                            <!-- <div class="col-12 mb-3">eSignatures are legal, trusted and enforceable in many countries around the world. The usage was boosted during Covid19 Pandemic around year 2021 as many businesses continued to operate as usual but the country was being locked down. Many people were forced to work from home (WFH), some of them started to use eSignature to sign agreements, contracts and forms online.</div> -->
                            <div class="col-12 mb-3">eSignature is extremely convenient, especially useful for multinational companies (MNC) with staff working at different locations and beneficials for all kinds of online agreements. There are plenty of software in the market that provide eSignature features, such as the very user-friendly "Preview" that comes pre-installed on all MacOS. However, most of the eSignature tools are merely a pdf reader with simple editor capability, to scan or upload your physically signed signature on a piece of white paper and then paste on the pdf documents to simulate the e-signing process.</div>
                    </div>
                    </div>
                </div>

                <div v-if="showMoreWhy === true" class="col-12 bg-grey mb-4">
                    <div class="greyContent text-white pt-3">
                        <div class="mb-3 fw-bold">Common Fraud Examples</div>
                        <div class="mb-3">
                            <ul>
                                <li>You realized your signed pdf document is being modified by someone and later distributed to others without your permission?</li>
                                <li>We can replace 2 pages out of 100 pages of a physically signed agreement, after it is already legally stamped, provided both parties agree to swap the pages. What if we swap additional pages? Who is holding the records?</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div v-if="showMoreWhy === true" class="col-12 mt-3">
                    <div class="greyContent">
                        <div class="row">
                            <div class="col-12 col-lg-6 d-grid mb-3">
                                <div class="boxFlow border shadow-sm px-4 pt-4">
                                    <div class="fw-bold mb-2">This is where the problems start</div>
                                    <div>
                                        <ul>
                                            <li>Physical signatures can be forged.</li>
                                            <li>eSignatures can be forged as well, copy and paste.</li>
                                            <li>Physical documents can be altered after you sign.</li>
                                            <li>Digital paper (pdf document) can be modified after you sign.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-lg-6 d-grid mb-3">
                                <div class="boxFlow border shadow-sm p-3 bg-primary text-white px-4 pt-4">
                                    <div class="fw-bold mb-2">There is no unbreakable lock, we need a simple yet effective solution to</div>
                                    <div>
                                        <ul>
                                            <li>Validate the origin of the documents.</li>
                                            <li>Verify the senders, organizations and signees.</li>
                                            <li>Trace all the signing processes with full audit logs.</li>
                                            <li>Hold the encrypted pdf documents and records by a third party without conflict of interests.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="showMoreWhy === true" class="col-12 mt-3">
                    <div class="greyContent">
                        <div class="mb-3">This is what sets us apart from the competitions. SignOn solves all the problems above for you. Furthermore, we are launching a series of integrated solutions to assist your business, such as API, Workflow, Form Designer, etc. Forget about spending hundreds of thousands before you start your business, but scale with our solutions, grow together with us.</div>
                        <div class="mt-2 mb-4">
                            <span class="text-info isLink" @click="goFeature()">Compare SignOn with Brand A</span>
                            <span class="float-end text-info isLink" @click="showMoreWhy = !showMoreWhy">Less</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div id="secWhoWeAre"></div>
    <div class="homeContainer">
        <div class="row">
            <div class="col-12 text-center secTitle">Who we are</div>
            <div class="col-12 boxFlow border shadow-sm d-none d-lg-block pb-0">
                <div class="row">
                    <!-- <div class="col-lg-6 whoWeAreImg"></div> -->
                    <div class="col-lg-6 ps-0 pb-0">
                        <img src="../assets/home/kl_map.webp" class="img-fluid" loading="lazy" decoding="async" style="border-top-left-radius: 10px; border-bottom-left-radius: 10px;" />
                    </div>
                    <div class="col-lg-6 p-4 lblStepSubDesc">
                        <div class="mb-3">We are an emerging startup based in Malaysia, Asia Pacific, proudly introducing our first product—eSignature, a fully homegrown innovation.</div>
                        <div class="mb-3">Our platform is completely free for fair usage, and we are committed to making it as intuitive and user-friendly as possible.</div>
                        <div class="mb-3">We value your feedback, suggestions, and investments opportunities as we continue to improve.</div>
                        <div class="mb-3">Try it out today and share it with your friends and colleagues.</div> 
                        <div class="mb-4">Thank you for your support!</div>
                        <div>
                            <button class="btn btn-info text-white btn-lg me-4" @click="goTrial" style="width: 200px">Free Trial</button>
                            <button class="btn btn-outline-info btn-lg btnVerify" @click="$router.push({ path: '/company'})" style="width: 200px">Contact Us</button>
                        </div>

                        <!-- <div class="mb-2">Please try it <a href="https://app.signon.my/auth/signup" class="text-primary">here</a>, and share the app with your friends and colleagues.</div>
                        <div class="mb-2">Thanks!</div> -->
                    </div>
                </div>
            </div>

            <div class="d-lg-none">
                <div class="col-12 mb-2 px-1">
                    <img src="../assets/home/kl_map.webp" class="img-fluid" style="border-radius: 10px" />
                </div>

                <div class="col-12 py-4 px-1 lblStepSubDesc">
                    <div class="mb-3">We are an emerging startup based in Malaysia, Asia Pacific, proudly introducing our first product—eSignature, a fully homegrown innovation.</div>
                    <div class="mb-3">Our platform is completely free for fair usage, and we are committed to making it as intuitive and user-friendly as possible.</div>
                    <div class="mb-3">We value your feedback, suggestions, and investments opportunities as we continue to improve.</div>
                    <div class="mb-3">Try it out today and share it with your friends and colleagues.</div> 
                    <div class="mb-4">Thank you for your support!</div>
                    <div>
                        <button class="btn btn-info text-white btn-lg me-3" @click="goTrial" style="width: 140px">Free Trial</button>
                        <button class="btn btn-outline-info btn-lg btnVerify" @click="$router.push({ path: '/company'})" style="width: 140px">Contact Us</button>
                    </div>
                </div>

            </div>
            
        </div>
    </div>

    <!-- 2025-06-06 Enerson request temp hide
    <div id="secExclusive"></div>
    <div class="homeContainer pb-4">
        <div class="row">
            <div class="col-12 text-center secTitle">Exclusive pre-launch deal</div>
            <div class="col-12 boxFlow border shadow-sm d-none d-lg-block">
                <div class="row">
                    <div class="col-lg-6 exclusiveImg"></div>
                    <div class="col-lg-6 p-4 lblStepSubDesc">
                        <div class="mb-2">SignOn's eSignature goes live in April 2023. </div>
                        <div class="mb-2">We are still touching up the user interface, description and documentations, but it should not affect the productivity and usability.</div> 
                        <div>As a token of appreciation, we are giving away 100 credits free to anyone who sign up today, a limited-time offer.</div>
                    </div>
                </div>
            </div>

            <div class="d-lg-none">
                <div class="col-12 mb-2">
                    <img src="../assets/home/rocket.jpg" class="img-fluid" style="border-radius: 10px" />
                </div>

                <div class="col-12 p-4 lblStepSubDesc">
                    <div class="mb-2">SignOn's eSignature goes live in April 2023. </div>
                    <div class="mb-2">We are still touching up the user interface, description and documentations, but it should not affect the productivity and usability.</div> 
                    <div>As a token of appreciation, we are giving away 100 credits free to anyone who sign up today, a limited-time offer.</div>
                </div>
            </div>
        </div>
    </div> -->


    <div id="pricing"></div>
    <div class="homeContainer pt-0">
        <div class="row">
            <div class="col-12 text-center secTitle">Pricing</div>
        </div>

        <!-- Large screen -->
        <div class="generalBorderlessBox d-none d-md-block">
            <div class="row">
                <div class="col-12">
                    <table>
                        <tr>
                            <td>
                                <div class="btn-group">
                                    <a href="#pricing" class="btn btn-sm" :class="payOpt === 'monthly' ? 'btn-info text-white' : 'border'" @click="payOpt = 'monthly'">No Commitment</a>
                                    <a href="#pricing" class="btn btn-sm" :class="payOpt === 'yearly' ? 'btn-info text-white' : 'border'" @click="payOpt = 'yearly'">1 Year Commitment</a>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>

                <div v-if="payOpt === 'yearly'" class="col-12 pt-3 pb-2 fst-italic text-grey">
                    Price shown is yearly subscription with monthly recurring charges.
                </div>
                <div v-else class="col-12">&nbsp;</div>

                <div v-if="arrPlan[0] && arrPlan[0].plan === 'FREE'" class="col-12 col-md-6 col-lg-3 d-grid">
                    <div class="planBox border shadow-sm">
                        <div class="planHeader">&nbsp;</div>
                        <div class="text-center mb-1">
                            <h5>{{ func.convStringCapitalize(arrPlan[0].plan) }}</h5>
                        </div>
                        <div class="text-center">
                            <span class="boxTitle ps-1">FOC</span>
                        </div>
                        <div class="text-center small text-grey">&nbsp</div>

                        <div class="boxButton d-grid">
                            <!-- <button v-if="getPackage === null" class="btn btn-info text-white btn-lg btn-block mb-5" data-bs-toggle="modal" data-bs-target="#mdlPreSubscription">Subscribe</button> -->
                            <a v-if="getPackage === null" href="https://app.signon.my/plan" class="btn btn-info text-white btn-lg btn-block text-white mb-5">Subscribe</a>
                            <button v-if="getPackage === 'FREE'" class="btn btn-secondary btn-lg btn-block mb-5" disabled>Subscribe</button>
                            <!-- <button v-if="getPackage !== null && getPackage !== 'FREE' && isFinance === true" class="btn btn-info text-white btn-lg btn-block mb-5" data-bs-target="#mdlPreSubscription">Subscribe</button> -->
                            <a v-if="getPackage !== null && getPackage !== 'FREE' && isFinance === true" href="https://app.signon.my/plan" class="btn btn-info text-white btn-lg btn-block text-white mb-5">Subscribe</a>
                            <button v-if="getPackage !== null && getPackage !== 'FREE' && isFinance === false" class="btn btn-info text-white btn-lg btn-block mb-5" disabled>Subscribe</button>
                        </div>

                        <div class="boxContent">
                            <table class="table table-borderless table-sm">
                                <tbody>
                                    <tr>
                                        <td width="25px" class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                        <td><span class="fw-bold">{{ arrPlan[0].userMonthlyCreditLimit }}</span> sign requests / month</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                        <td><span class="fw-bold">{{ arrPlan[0].userStorageLimit }}</span> storage / user</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                        <td><span class="fw-bold">{{ arrPlan[0].userMonthlyCreditLimit }}</span> user credit / month</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                        <td><span class="fw-bold">{{ arrPlan[0].memberSizeLimit }}</span> users limit</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                        <td><span class="fw-bold">{{ arrPlan[0].teamSizeLimit }}</span> teams limit</td>
                                    </tr>
                                    <!-- <tr>
                                        <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                        <td><span class="fw-bold">1</span> API</td>
                                    </tr> -->
                                    <tr>
                                        <td colspan="2" class="px-0 py-0 my-0"><hr /></td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0 align-top">
                                            <i v-if="arrPlan[0].enableDocAndSignatureValidation === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[0].enableDocAndSignatureValidation === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Document & signature validations</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0">
                                            <i v-if="arrPlan[0].enableEntityAndUserValidation === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[0].enableEntityAndUserValidation === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Entity & user validations</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0">
                                            <i v-if="arrPlan[0].enableSignDocument === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[0].enableSignDocument === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Sign documents</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0 align-top">
                                            <i v-if="arrPlan[0].enableDownload === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[0].enableDownload === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Download folder & documents</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0 align-top">
                                            <i v-if="arrPlan[0].enableAuditTrial === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[0].enableAuditTrial === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Audit trials on folder and individual documents</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0">
                                            <i v-if="arrPlan[0].enableTeam === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[0].enableTeam === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Work as team</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0">
                                            <i v-if="arrPlan[0].enableSealFolder === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[0].enableSealFolder === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Seal folder protection</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0">
                                            <i v-if="arrPlan[0].enableWorkflow === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[0].enableWorkflow === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>PDF workflow</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0">
                                            <i v-if="arrPlan[0].enableReferralIncentive === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[0].enableReferralIncentive === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Referral incentives</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="px-0 py-0 my-0"><hr /></td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0 align-top">
                                            <i v-if="arrPlan[0].enableSharedRack === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[0].enableSharedRack === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td><span class="fw-bold">Shared rack</span> for team storage</td>
                                    </tr>
                                    <tr v-if="showMore === true">
                                        <td colspan="2" class="px-0 py-0 my-0"><hr /></td>
                                    </tr>
                                    <tr v-if="showMore === true">
                                        <td class="ps-0 align-top iconBlue"><i class="fa-solid fa-asterisk"></i></td>
                                        <td>
                                            <span v-if="arrPlan[0].dayToDeleteShreddedNotSealedFolder === 0">
                                                Non-sealed folders that have been shredded will be destruct <strong>immediately</strong>
                                            </span>
                                            <span v-else>
                                                Non-sealed folders that have been shredded will be retained for <strong>{{ arrPlan[0].dayToDeleteShreddedNotSealedFolder }}</strong> days before destruction
                                            </span>
                                        </td>
                                    </tr>
                                    <tr v-if="showMore === true">
                                        <td class="ps-0 align-top iconBlue"><i class="fa-solid fa-asterisk"></i></td>
                                        <td>
                                            <span v-if="arrPlan[0].dayToDeleteShreddedSealedFolder === 0">
                                                Sealed folders that have been shredded will be destruct <strong>immediately</strong>
                                            </span>
                                            <span v-else>
                                                Sealed folders that have been shredded will be retained for <strong>{{ arrPlan[0].dayToDeleteShreddedSealedFolder }}</strong> days before destruction
                                            </span>
                                        </td>
                                    </tr>
                                    <tr v-if="showMore === true">
                                        <td class="ps-0 align-top iconBlue"><i class="fa-solid fa-asterisk"></i></td>
                                        <td>
                                            <span v-if="arrPlan[0].dayToDeleteShreddedSealedDocument === 0">
                                                Sealed documents that have been shredded will be destruct <strong>immediately</strong>
                                            </span>
                                            <span v-else>
                                                Sealed documents that have been shredded will be retained for <strong>{{ arrPlan[0].dayToDeleteShreddedSealedDocument }}</strong> days before destruction
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                    </div>
                </div>

                <div v-if="arrPlan[1] && arrPlan[1].plan === 'STARTER'" class="col-12 col-md-6 col-lg-3 d-grid">
                    <div class="planBoxReco shadow-sm">
                        <div class="planHeaderReco text-white">
                            Recommended
                        </div>
                        <div class="text-center mb-1">
                            <h5>{{ func.convStringCapitalize(arrPlan[1].plan) }}</h5>
                        </div>
                        <div class="text-center mb-0 pb-0">
                            <span class="fw-bold text-uppercase">{{ arrPlan[1].currency }}</span>
                            <span class="boxTitle ps-1">{{ arrPlan[1].chargePerUser }}</span>
                            <span> / user</span>
                        </div>

                        <div v-if="payOpt === 'monthly'" class="text-center small text-grey">per month, no commitment</div>
                        <div v-if="payOpt === 'yearly'" class="text-center small text-grey">per month, 1-year commitment</div>
                            
                        <div class="boxButton d-grid">
                            <!-- <button v-if="getPackage === null" class="btn btn-info text-white btn-lg btn-block mb-5" data-bs-toggle="modal" data-bs-target="#mdlPreSubscription">Subscribe</button> -->
                            <a v-if="getPackage === null" href="https://app.signon.my/plan" class="btn btn-info text-white btn-lg btn-block text-white mb-5">Subscribe</a>
                            <button v-if="getPackage === 'STARTER'" class="btn btn-secondary btn-lg btn-block mb-5" disabled>Subscribe</button>
                            <!-- <button v-if="getPackage !== null && getPackage !== 'STARTER' && isFinance === true" class="btn btn-info text-white btn-lg btn-block mb-5" data-bs-toggle="modal" data-bs-target="#mdlConfirmSubscription" @click="preCheckout(arrPlan[1].plan, arrPlan[1].currency, arrPlan[1].chargePerUser, arrPlan[1].memberSizeLimit)">Subscribe</button> -->
                            <a v-if="getPackage !== null && getPackage !== 'STARTER' && isFinance === true" href="https://app.signon.my/plan" class="btn btn-info text-white btn-lg btn-block text-white mb-5">Subscribe</a>
                            <button v-if="getPackage !== null && getPackage !== 'STARTER' && isFinance === false" class="btn btn-info text-white btn-lg btn-block mb-5" disabled>Subscribe</button>
                        </div>

                        <div class="boxContent">
                            <table class="table table-borderless table-sm">
                                <tbody>
                                    <tr>
                                        <td width="25px" class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                        <td><span class="fw-bold">{{ arrPlan[1].userMonthlyCreditLimit }}</span> sign requests / month</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                        <td><span class="fw-bold">{{ arrPlan[1].userStorageLimit }}</span> storage / user</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                        <td><span class="fw-bold">{{ arrPlan[1].userMonthlyCreditLimit }}</span> user credit / month</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                        <td><span class="fw-bold">{{ arrPlan[1].memberSizeLimit }}</span> users limit</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                        <td><span class="fw-bold">{{ arrPlan[1].teamSizeLimit }}</span> teams limit</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="px-0 py-0 my-0"><hr /></td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0 align-top">
                                            <i v-if="arrPlan[1].enableDocAndSignatureValidation === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[1].enableDocAndSignatureValidation === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Document & signature validations</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0">
                                            <i v-if="arrPlan[1].enableEntityAndUserValidation === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[1].enableEntityAndUserValidation === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Entity & user validations</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0">
                                            <i v-if="arrPlan[1].enableSignDocument === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[1].enableSignDocument === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Sign documents</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0 align-top">
                                            <i v-if="arrPlan[1].enableDownload === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[1].enableDownload === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Download folder & documents</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0 align-top">
                                            <i v-if="arrPlan[1].enableAuditTrial === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[1].enableAuditTrial === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Audit trials on folder and individual documents</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0">
                                            <i v-if="arrPlan[1].enableTeam === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[1].enableTeam === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Work as team</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0">
                                            <i v-if="arrPlan[1].enableSealFolder === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[1].enableSealFolder === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Seal folder protection</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0">
                                            <i v-if="arrPlan[1].enableWorkflow === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[1].enableWorkflow === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>PDF workflow</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0">
                                            <i v-if="arrPlan[1].enableReferralIncentive === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[1].enableReferralIncentive === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Referral incentives</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="px-0 py-0 my-0"><hr /></td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0 align-top">
                                            <i v-if="arrPlan[1].enableSharedRack === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[1].enableSharedRack === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td><span class="fw-bold">Shared rack</span> for team storage</td>
                                    </tr>
                                    <tr v-if="showMore === true">
                                        <td colspan="2" class="px-0 py-0 my-0"><hr /></td>
                                    </tr>
                                    <tr v-if="showMore === true">
                                        <td class="ps-0 align-top iconBlue"><i class="fa-solid fa-asterisk"></i></td>
                                        <td>
                                            <span v-if="arrPlan[1].dayToDeleteShreddedNotSealedFolder === 0">
                                                Non-sealed folders that have been shredded will be destruct <strong>immediately</strong>
                                            </span>
                                            <span v-else>
                                                Non-sealed folders that have been shredded will be retained for <strong>{{ arrPlan[1].dayToDeleteShreddedNotSealedFolder }}</strong> days before destruction
                                            </span>
                                        </td>
                                    </tr>
                                    <tr v-if="showMore === true">
                                        <td class="ps-0 align-top iconBlue"><i class="fa-solid fa-asterisk"></i></td>
                                        <td>
                                            <span v-if="arrPlan[1].dayToDeleteShreddedSealedFolder === 0">
                                                Sealed folders that have been shredded will be destruct <strong>immediately</strong>
                                            </span>
                                            <span v-else>
                                                Sealed folders that have been shredded will be retained for <strong>{{ arrPlan[1].dayToDeleteShreddedSealedFolder }}</strong> days before destruction
                                            </span>
                                        </td>
                                    </tr>
                                    <tr v-if="showMore === true">
                                        <td class="ps-0 align-top iconBlue"><i class="fa-solid fa-asterisk"></i></td>
                                        <td>
                                            <span v-if="arrPlan[1].dayToDeleteShreddedSealedDocument === 0">
                                                Sealed documents that have been shredded will be destruct <strong>immediately</strong>
                                            </span>
                                            <span v-else>
                                                Sealed documents that have been shredded will be retained for <strong>{{ arrPlan[1].dayToDeleteShreddedSealedDocument }}</strong> days before destruction
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div v-if="arrPlan[2] && arrPlan[2].plan === 'STANDARD'" class="col-12 col-md-6 col-lg-3 d-grid">
                    <div class="planBox border shadow-sm">
                        <div class="planHeader">
                            <span v-if="getPackage === null || isFinance === true" class="iconBlue isLink" @click="getTrial('STANDARD')">Start a trial</span>
                            <span v-else class="text-secondary">Start a trial</span>
                        </div>
                        <div class="text-center mb-1">
                            <h5>{{ func.convStringCapitalize(arrPlan[2].plan) }}</h5>
                        </div>
                        <div class="text-center">
                            <span class="fw-bold text-uppercase">{{ arrPlan[2].currency }}</span>
                            <span class="boxTitle ps-1">{{ arrPlan[2].chargePerUser }}</span>
                            <span> / user</span>
                        </div>

                        <div v-if="payOpt === 'monthly'" class="text-center small text-grey">per month, no commitment</div>
                        <div v-if="payOpt === 'yearly'" class="text-center small text-grey">per month, 1-year commitment</div>

                        <div class="boxButton d-grid">
                            <!-- <button v-if="getPackage === null" class="btn btn-info text-white btn-lg btn-block mb-5" data-bs-toggle="modal" data-bs-target="#mdlPreSubscription">Subscribe</button> -->
                            <a v-if="getPackage === null" href="https://app.signon.my/plan" class="btn btn-info text-white btn-lg btn-block text-white mb-5">Subscribe</a>
                            <button v-if="getPackage === 'STANDARD'" class="btn btn-secondary btn-lg btn-block mb-5" disabled>Subscribed</button>
                            <!-- <button v-if="getPackage !== null && getPackage !== 'STANDARD' && isFinance === true" class="btn btn-info text-white btn-lg btn-block mb-5" data-bs-toggle="modal" data-bs-target="#mdlConfirmSubscription" @click="preCheckout(arrPlan[2].plan, arrPlan[2].currency, arrPlan[2].chargePerUser, arrPlan[2].memberSizeLimit)">Subscribe</button> -->
                            <a v-if="getPackage !== null && getPackage !== 'STANDARD' && isFinance === true" href="https://app.signon.my/plan" class="btn btn-info text-white btn-lg btn-block text-white mb-5">Subscribe</a>
                            <button v-if="getPackage !== null && getPackage !== 'STANDARD' && isFinance === false" class="btn btn-info text-white btn-lg btn-block mb-5" disabled>Subscribe</button>
                        </div>

                        <div class="boxContent">
                            <table class="table table-borderless table-sm">
                                <tbody>
                                    <tr>
                                        <td width="25px" class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                        <td><span class="fw-bold">{{ arrPlan[2].userMonthlyCreditLimit }}</span> sign requests / month</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                        <td><span class="fw-bold">{{ arrPlan[2].userStorageLimit }}</span> storage / user</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                        <td><span class="fw-bold">{{ arrPlan[2].userMonthlyCreditLimit }}</span> user credit / month</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                        <td><span class="fw-bold">{{ arrPlan[2].memberSizeLimit }}</span> users limit</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                        <td><span class="fw-bold">{{ arrPlan[2].teamSizeLimit }}</span> teams limit</td>
                                    </tr>
                                    <!-- <tr>
                                        <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                        <td><span class="fw-bold">99</span> APIs</td>
                                    </tr> -->
                                    <tr>
                                        <td colspan="2" class="px-0 py-0 my-0"><hr /></td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0 align-top">
                                            <i v-if="arrPlan[2].enableDocAndSignatureValidation === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[2].enableDocAndSignatureValidation === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Document & signature validations</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0">
                                            <i v-if="arrPlan[2].enableEntityAndUserValidation === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[2].enableEntityAndUserValidation === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Entity & user validations</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0">
                                            <i v-if="arrPlan[2].enableSignDocument === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[2].enableSignDocument === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Sign documents</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0 align-top">
                                            <i v-if="arrPlan[2].enableDownload === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[2].enableDownload === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Download folder & documents</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0 align-top">
                                            <i v-if="arrPlan[2].enableAuditTrial === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[2].enableAuditTrial === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Audit trials on folder and individual documents</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0">
                                            <i v-if="arrPlan[2].enableTeam === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[2].enableTeam === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Work as team</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0">
                                            <i v-if="arrPlan[2].enableSealFolder === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[2].enableSealFolder === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Seal folder protection</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0">
                                            <i v-if="arrPlan[2].enableWorkflow === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[2].enableWorkflow === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>PDF workflow</td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0">
                                            <i v-if="arrPlan[2].enableReferralIncentive === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[2].enableReferralIncentive === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td>Referral incentives</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="px-0 py-0 my-0">
                                            <hr style=""/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="ps-0 align-top">
                                            <i v-if="arrPlan[2].enableSharedRack === true" class="fa-solid fa-check fa-lg iconBlue"></i>
                                            <i v-if="arrPlan[2].enableSharedRack === false" class="fa-solid fa-xmark fa-xl text-grey"></i>
                                        </td>
                                        <td><span class="fw-bold">Shared rack</span> for team storage</td>
                                    </tr>
                                    <tr v-if="showMore === true">
                                        <td colspan="2" class="px-0 py-0 my-0">
                                            <hr />
                                        </td>
                                    </tr>
                                    <tr v-if="showMore === true">
                                        <td class="ps-0 align-top iconBlue"><i class="fa-solid fa-asterisk"></i></td>
                                        <td>
                                            <span v-if="arrPlan[2].dayToDeleteShreddedNotSealedFolder === 0">
                                                Non-sealed folders that have been shredded will be destruct <strong>immediately</strong>
                                            </span>
                                            <span v-else>
                                                Non-sealed folders that have been shredded will be retained for <strong>{{ arrPlan[2].dayToDeleteShreddedNotSealedFolder }}</strong> days before destruction
                                            </span>
                                        </td>
                                    </tr>
                                    <tr v-if="showMore === true">
                                        <td class="ps-0 align-top iconBlue"><i class="fa-solid fa-asterisk"></i></td>
                                        <td>
                                            <span v-if="arrPlan[2].dayToDeleteShreddedSealedFolder === 0">
                                                Sealed folders that have been shredded will be destruct <strong>immediately</strong>
                                            </span>
                                            <span v-else>
                                                Sealed folders that have been shredded will be retained for <strong>{{ arrPlan[2].dayToDeleteShreddedSealedFolder }}</strong> days before destruction
                                            </span>
                                        </td>
                                    </tr>
                                    <tr v-if="showMore === true">
                                        <td class="ps-0 align-top iconBlue"><i class="fa-solid fa-asterisk"></i></td>
                                        <td>
                                            <span v-if="arrPlan[2].dayToDeleteShreddedSealedDocument === 0">
                                                Sealed documents that have been shredded will be destruct <strong>immediately</strong>
                                            </span>
                                            <span v-else>
                                                Sealed documents that have been shredded will be retained for <strong>{{ arrPlan[2].dayToDeleteShreddedSealedDocument }}</strong> days before destruction
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>

                <div class="col-12 col-md-6 col-lg-3">
                    <div class="planBox border shadow-sm">
                        <div class="planHeader">&nbsp;</div>
                        <div class="text-center mb-1">
                            <h5>Enterprise</h5>
                        </div>
                        <div class="text-center mt-4" style="padding-bottom: 16px">
                            <div class="fw-bold">Price</div>
                            <div class="fw-bold">Upon Request</div>
                        </div>
                        <div class="text-center small text-grey">&nbsp</div>

                        <div class="boxButton d-grid">
                            <button v-if="getPackage === null || isFinance === true" class="btn btn-info text-white btn-lg btn-block mb-5" data-bs-toggle="modal" data-bs-target="#mdlTalk">Talk to Us</button>
                            <button v-else class="btn btn-info text-white text-white btn-lg btn-block mb-5" disabled>Talk to Us</button>
                        </div>

                        <div class="text-center mb-3" style="line-height: 2">
                            The final price is based on customization.<br />Please reach out to discuss your specific needs.
                        </div>
                    </div>
                </div>

                <div class="col-12">
                    <div v-if="showMore === false" @click="showMore = true" class="isLink text-info">Show more</div>
                    <div v-else @click="showMore = false" class="isLink text-info">Show less</div>
                </div>
                <div class="col-12 mt-2 fst-italic fw-light">
                    <div><i class="fa-solid fa-star-of-life fa-xs text-grey me-1"></i>FREE one-time 30 credits upon successful KYC.</div>
                </div>
            </div>
        </div>

        <!-- Small screen-->
        <div class="generalBorderlessBox d-md-none">
            <div class="row">
                <div class="col-12">
                    <table>
                        <tr>
                            <td>
                                <div class="btn-group">
                                    <a href="#pricing" class="btn btn-sm" :class="payOpt === 'monthly' ? 'btn-info text-white' : 'border'" @click="payOpt = 'monthly'">No Commitment</a>
                                    <a href="#pricing" class="btn btn-sm" :class="payOpt === 'yearly' ? 'btn-info text-white' : 'border'" @click="payOpt = 'yearly'">1 Year Commitment</a>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>

                <div v-if="payOpt === 'yearly'" class="col-12 pt-3 pb-2 fst-italic text-grey">
                    Price shown is yearly subscription with monthly recurring charges.
                </div>
                <div v-else class="col-12">&nbsp;</div>
            </div> 

            <!-- Carousel -->
            <div id="planSm" class="carousel slide" data-bs-ride="carousel">

                <!-- Indicators/dots -->
                <div class="carousel-indicators mb-0">
                    <button type="button" data-bs-target="#planSm" data-bs-slide-to="0" class="active"></button>
                    <button type="button" data-bs-target="#planSm" data-bs-slide-to="1"></button>
                    <button type="button" data-bs-target="#planSm" data-bs-slide-to="2"></button>
                    <button type="button" data-bs-target="#planSm" data-bs-slide-to="3"></button>
                </div>

                <!-- The slideshow/carousel -->
                <div class="carousel-inner">
                    <!-- Plan: free -->
                    <div class="carousel-item active">
                        <div v-if="arrPlan[0] && arrPlan[0].plan === 'FREE'">
                            <div class="planBox border shadow-sm">
                                <div class="planHeader">&nbsp;</div>
                                <div class="planBoxContainerSm">
                                    <div class="text-center mb-1">
                                        <h6>{{ func.convStringCapitalize(arrPlan[0].plan) }}</h6>
                                    </div>
                                    <div class="text-center">
                                        <span class="boxTitleSm ps-1">FOC</span>
                                    </div>

                                    <div class="boxButton d-grid">
                                        <button v-if="getPackage === null" class="btn btn-info text-white btn-lg btn-block mb-5" data-bs-toggle="modal" data-bs-target="#mdlPreSubscription">Subscribe</button>
                                        <button v-if="getPackage === 'FREE'" class="btn btn-secondary btn-lg btn-block mb-5" disabled>Subscribed</button>
                                        <button v-if="getPackage !== null && getPackage !== 'FREE' && isFinance === true" class="btn btn-info text-white btn-lg btn-block mb-5" data-bs-target="#mdlPreSubscription">Subscribe</button>
                                        <button v-if="getPackage !== null && getPackage !== 'FREE' && isFinance === false" class="btn btn-info text-white btn-lg btn-block mb-5" disabled>Subscribe</button>
                                    </div>

                                    <div class="boxContent">
                                        <table class="table table-borderless table-sm">
                                            <tbody>
                                                <tr>
                                                    <td width="25px" class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                                    <td><span class="fw-bold">{{ arrPlan[0].userMonthlyCreditLimit }}</span> sign requests / month</td>
                                                </tr>
                                                <tr>
                                                    <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                                    <td><span class="fw-bold">{{ arrPlan[0].userStorageLimit }}</span> storage / user</td>
                                                </tr>
                                                <tr>
                                                    <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                                    <td><span class="fw-bold">{{ arrPlan[0].userMonthlyCreditLimit }}</span> user credit / month</td>
                                                </tr>
                                                <tr>
                                                    <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                                    <td><span class="fw-bold">{{ arrPlan[0].memberSizeLimit }}</span> users limit</td>
                                                </tr>
                                                <tr>
                                                    <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                                    <td>
                                                        <span class="fw-bold">{{ arrPlan[0].teamSizeLimit }}</span> teams limit
                                                        <span class="float-end text-info isLink small mb-2" @click="$router.push({ path: '/plan/' + arrPlan[0].plan })">More</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Plan: starter -->
                    <div class="carousel-item">
                        <div v-if="arrPlan[1] && arrPlan[1].plan === 'STARTER'">
                            <div class="planBoxReco shadow-sm">
                                <div class="planHeaderReco text-white">
                                    Recommended
                                </div>
                                <div class="planBoxContainerSm">
                                    <div class="text-center mb-1">
                                        <h6>{{ func.convStringCapitalize(arrPlan[1].plan) }}</h6>
                                    </div>
                                    <div class="text-center mb-0 pb-0">
                                        <span class="fw-bold text-uppercase">{{ arrPlan[1].currency }}</span>
                                        <span class="boxTitleSm ps-1">{{ arrPlan[1].chargePerUser }}</span>
                                        <span> / user</span>
                                    </div>

                                    <div v-if="payOpt === 'monthly'" class="text-center small text-grey">per month, no commitment</div>
                                    <div v-if="payOpt === 'yearly'" class="text-center small text-grey">per month, 1-year commitment</div>
                                        
                                    <div class="boxButton d-grid">
                                        <button v-if="getPackage === null" class="btn btn-info text-white btn-lg btn-block mb-5" data-bs-toggle="modal" data-bs-target="#mdlPreSubscription">Subscribe</button>
                                        <button v-if="getPackage === 'STARTER'" class="btn btn-secondary btn-lg btn-block mb-5" disabled>Subscribed</button>
                                        <button v-if="getPackage !== null && getPackage !== 'STARTER' && isFinance === true" class="btn btn-info text-white btn-lg btn-block mb-5" data-bs-toggle="modal" data-bs-target="#mdlConfirmSubscription" @click="preCheckout(arrPlan[1].plan, arrPlan[1].currency, arrPlan[1].chargePerUser, arrPlan[1].memberSizeLimit)">Subscribe</button>
                                        <button v-if="getPackage !== null && getPackage !== 'STARTER' && isFinance === false" class="btn btn-info text-white btn-lg btn-block mb-5" disabled>Subscribe</button>
                                    </div>

                                    <div class="boxContent">
                                        <table class="table table-borderless table-sm">
                                            <tbody>
                                                <tr>
                                                    <td width="25px" class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                                    <td><span class="fw-bold">{{ arrPlan[1].userMonthlyCreditLimit }}</span> sign requests / month</td>
                                                </tr>
                                                <tr>
                                                    <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                                    <td><span class="fw-bold">{{ arrPlan[1].userStorageLimit }}</span> storage / user</td>
                                                </tr>
                                                <tr>
                                                    <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                                    <td><span class="fw-bold">{{ arrPlan[1].userMonthlyCreditLimit }}</span> user credit / month</td>
                                                </tr>
                                                <tr>
                                                    <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                                    <td><span class="fw-bold">{{ arrPlan[1].memberSizeLimit }}</span> users limit</td>
                                                </tr>
                                                <tr>
                                                    <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                                    <td>
                                                        <span class="fw-bold">{{ arrPlan[1].teamSizeLimit }}</span> teams limit
                                                        <span class="float-end text-info isLink small mb-2" @click="$router.push({ path: '/plan/' + arrPlan[1].plan })">More</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Plan: standard -->
                    <div class="carousel-item">
                        <div v-if="arrPlan[2] && arrPlan[2].plan === 'STANDARD'">
                            <div class="planBox border shadow-sm">
                                <div class="planHeader">
                                    <span v-if="getPackage === null || isFinance === true" class="iconBlue isLink" @click="getTrial('STANDARD')">Start a trial</span>
                                    <span v-else class="text-secondary">Start a trial</span>
                                </div>
                                <div class="planBoxContainerSm">
                                    <div class="text-center mb-1">
                                        <h6>{{ func.convStringCapitalize(arrPlan[2].plan) }}</h6>
                                    </div>
                                    <div class="text-center">
                                        <span class="fw-bold text-uppercase">{{ arrPlan[2].currency }}</span>
                                        <span class="boxTitleSm ps-1">{{ arrPlan[2].chargePerUser }}</span>
                                        <span> / user</span>
                                    </div>

                                    <div v-if="payOpt === 'monthly'" class="text-center small text-grey">per month, no commitment</div>
                                    <div v-if="payOpt === 'yearly'" class="text-center small text-grey">per month, 1-year commitment</div>

                                    <div class="boxButton d-grid">
                                        <button v-if="getPackage === null" class="btn btn-info text-white btn-lg btn-block mb-5" data-bs-toggle="modal" data-bs-target="#mdlPreSubscription">Subscribe</button>
                                        <button v-if="getPackage === 'STANDARD'" class="btn btn-secondary btn-lg btn-block mb-5" disabled>Subscribed</button>
                                        <button v-if="getPackage !== null && getPackage !== 'STANDARD' && isFinance === true" class="btn btn-info text-white btn-lg btn-block mb-5" data-bs-toggle="modal" data-bs-target="#mdlConfirmSubscription" @click="preCheckout(arrPlan[2].plan, arrPlan[2].currency, arrPlan[2].chargePerUser, arrPlan[2].memberSizeLimit)">Subscribe</button>
                                        <button v-if="getPackage !== null && getPackage !== 'STANDARD' && isFinance === false" class="btn btn-info text-white btn-lg btn-block mb-5" disabled>Subscribe</button>
                                    </div>

                                    <div class="boxContent">
                                        <table class="table table-borderless table-sm">
                                            <tbody>
                                                <tr>
                                                    <td width="25px" class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                                    <td><span class="fw-bold">{{ arrPlan[2].userMonthlyCreditLimit }}</span> sign requests / month</td>
                                                </tr>
                                                <tr>
                                                    <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                                    <td><span class="fw-bold">{{ arrPlan[2].userStorageLimit }}</span> storage / user</td>
                                                </tr>
                                                <tr>
                                                    <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                                    <td><span class="fw-bold">{{ arrPlan[2].userMonthlyCreditLimit }}</span> user credit / month</td>
                                                </tr>
                                                <tr>
                                                    <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                                    <td><span class="fw-bold">{{ arrPlan[2].memberSizeLimit }}</span> users limit</td>
                                                </tr>
                                                <tr>
                                                    <td class="ps-0"><i class="fa-solid fa-check fa-lg iconBlue"></i></td>
                                                    <td>
                                                        <span class="fw-bold">{{ arrPlan[2].teamSizeLimit }}</span> teams limit
                                                        <span class="float-end text-info isLink small mb-2" @click="$router.push({ path: '/plan/' + arrPlan[2].plan })">More</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Plan: enterprise -->
                    <div class="carousel-item">
                        <div>
                            <div class="planBox border shadow-sm">
                                <div class="planHeader">&nbsp;</div>
                                <div class="planBoxContainerSm">
                                    <div class="text-center mb-1">
                                        <h6>Enterprise</h6>
                                    </div>
                                    <div class="text-center mt-4" style="padding-bottom: 16px">
                                        <div class="fw-bold">Price</div>
                                        <div class="fw-bold">Upon Request</div>
                                    </div>

                                    <div class="boxButton d-grid">
                                        <button v-if="getPackage === null || isFinance === true" class="btn btn-info text-white btn-lg btn-block mb-5" data-bs-toggle="modal" data-bs-target="#mdlTalk">Talk to Us</button>
                                        <button v-else class="btn btn-info text-white text-white btn-lg btn-block mb-5" disabled>Talk to Us</button>
                                    </div>

                                    <div class="text-center mb-3" style="line-height: 2">
                                        The final price is based on customization.<br />Please reach out to discuss your specific needs.
                                    </div>

                                    <!-- <div class="text-center mb-3"><br /></div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Left and right controls/icons -->
                <button class="carousel-control-prev" type="button" data-bs-target="#planSm" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon text-grey"></span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#planSm" data-bs-slide="next">
                    <span class="carousel-control-next-icon text-grey"></span>
                </button>
            </div>
            <!-- End Carousel -->

            <div class="col-12 mt-2 mb-5 fst-italic fw-light">
                <div><i class="fa-solid fa-star-of-life fa-xs text-grey me-1"></i>FREE one-time 30 credits upon successful KYC.</div>
            </div>

        </div>
        <!-- End: Small screen-->
    </div>

    <div class="homeContainer pt-0">
        <div class="row">
            <div class="col-12 text-center secTitle">FAQ</div>

            <div class="accordion" id="myFaq">

                <div class="accordion-item">
                    <div class="accordion-header" id="faq_1">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqc_1" aria-expanded="false" aria-controls="faqc_1">
                            <span class="faqTitle">Is SignOn eSignature free?</span>
                        </button>
                    </div>
                    <div id="faqc_1" class="accordion-collapse collapse" aria-labelledby="faq_1" data-bs-parent="#myFaq">
                        <div class="accordion-body">Yes, it is always free to sign via SignOn. We offer a free online account for normal users with reasonable usage, try <a href="https://app.signon.my/auth/signup"><u>signup free SignOn</u></a> account. There is an option to upgrade to paid service.</div>
                    </div>
                </div>

                <div class="accordion-item">
                    <div class="accordion-header" id="faq_2">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqc_2" aria-expanded="false" aria-controls="faqc_2">
                            <span class="faqTitle">Can I share my work with my teammates?</span>
                        </button>
                    </div>
                    <div id="faqc_2" class="accordion-collapse collapse" aria-labelledby="faq_2" data-bs-parent="#myFaq">
                        <div class="accordion-body">Yes, you may switch from Personal to Team mode anytime when you are ready to get your teammates on board. You can assign them as co-editors to share your workload. It is free.</div>
                    </div>
                </div>

                <div class="accordion-item">
                    <div class="accordion-header" id="faq_3">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqc_3" aria-expanded="false" aria-controls="faqc_3">
                            <span class="faqTitle">When do I need to upgrade to paid service?</span>
                        </button>
                    </div>
                    <div id="faqc_3" class="accordion-collapse collapse" aria-labelledby="faq_3" data-bs-parent="#myFaq">
                        <div class="accordion-body">We offer paid service for heavy users, usually for organizations with higher demand of usage and storage space. There are selections of plans that cater for your needs, check it out <u>here</u>.</div>
                    </div>
                </div>

                <div class="accordion-item">
                    <div class="accordion-header" id="faq_4">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqc_4" aria-expanded="false" aria-controls="faqc_4">
                            <span class="faqTitle">What is a rack, folder, and document in SignOn?</span>
                        </button>
                    </div>
                    <div id="faqc_4" class="accordion-collapse collapse" aria-labelledby="faq_4" data-bs-parent="#myFaq">
                        <div class="accordion-body">A folder is a container for documents that you send to a recipient (signee) to sign. A folder can keep more than one document, and can circulate to more than one signee. Folders have statuses (i.e. Work In Progress, Circulating, Sealed, Delete) and contain information about the sender and timestamps that track the eSigning progress. You may upgrade your rack to store your growing folders.</div>
                    </div>
                </div>

                <div class="accordion-item">
                    <div class="accordion-header" id="faq_5">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqc_5" aria-expanded="false" aria-controls="faqc_5">
                            <span class="faqTitle">How safe is SignOn?</span>
                        </button>
                    </div>
                    <div id="faqc_5" class="accordion-collapse collapse" aria-labelledby="faq_5" data-bs-parent="#myFaq">
                        <div class="accordion-body">All of SignOn's offerings include the highest levels of trust and security, industry leading user experience, and the flexibility to grow as your needs evolve. All your documents are encrypted and splitted to pieces before distributing</div>
                    </div>
                </div>

                <div class="accordion-item">
                    <div class="accordion-header" id="faq_6">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqc_6" aria-expanded="false" aria-controls="faqc_6">
                            <span class="faqTitle">What distinguishes us from competitors?</span>
                        </button>
                    </div>
                    <div id="faqc_6" class="accordion-collapse collapse" aria-labelledby="faq_6" data-bs-parent="#myFaq">
                        <div class="accordion-body">
                            <div class="mb-2">SignOn requires validated email for the eSigning process at the minimum security level. However, if requested by the sender, signees are required to be KYCed, or even upload the footage of affirmations or oath ceremonies. Senders may attach the scanned documents to the same folder for file keeping purposes.</div>
                            <div>SignOn offers validation and verification services on signees and organizations to minimize the phishing and fraudulent attempts. Our free online tool <a href="https://app.signon.my/doc/verify"><u>Verify Doc</u></a> that is available 24x7 checks the fingerprints of the documents to ensure your local digital copy is the same as the source copy.</div>
                        </div>
                    </div>
                </div>

                <div class="accordion-item">
                    <div class="accordion-header" id="faq_7">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqc_7" aria-expanded="false" aria-controls="faqc_7">
                            <span class="faqTitle">How to integrate SignOn with my app?</span>
                        </button>
                    </div>
                    <div id="faqc_7" class="accordion-collapse collapse" aria-labelledby="faq_7" data-bs-parent="#myFaq">
                        <div class="accordion-body">We provide free API and Open Source resources at the Developer Center. You may programme your apps to send quotations, invoices, offer letters and many other interactive eSigning processes with our API.</div>
                    </div>
                </div>

                <div class="accordion-item">
                    <div class="accordion-header" id="faq_8">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqc_8" aria-expanded="false" aria-controls="faqc_8">
                            <span class="faqTitle">How to incorporate workflow with eSignature?</span>
                        </button>
                    </div>
                    <div id="faqc_8" class="accordion-collapse collapse" aria-labelledby="faq_8" data-bs-parent="#myFaq">
                        <div class="accordion-body">eSignature with workflow helps improve your productivity, enhance communication, reduce errors and delays, increase efficiency and reduce cost in your organizations. You may use our built-in workflow designer to streamline your operational processes. This feature is available soon.</div>
                    </div>
                </div>

                <div class="accordion-item">
                    <div class="accordion-header" id="faq_9">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqc_9" aria-expanded="false" aria-controls="faqc_9">
                            <span class="faqTitle">Will my monthly/annual subscription be renewed automatically?</span>
                        </button>
                    </div>
                    <div id="faqc_9" class="accordion-collapse collapse" aria-labelledby="faq_9" data-bs-parent="#myFaq">
                        <div class="accordion-body">Yes, your subscription will automatically be renewed until you let us know that you'd like to change your plan or cancel your account.</div>
                    </div>
                </div>

                <div class="accordion-item">
                    <div class="accordion-header" id="faq_10">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqc_10" aria-expanded="false" aria-controls="faqc_10">
                            <span class="faqTitle">How do I cancel or downgrade my subscription?</span>
                        </button>
                    </div>
                    <div id="faqc_10" class="accordion-collapse collapse" aria-labelledby="faq_10" data-bs-parent="#myFaq">
                        <div class="accordion-body">You can cancel or downgrade your account anytime in your preferences section.</div>
                    </div>
                </div>

            </div>

        </div>
    </div>


    <!-- Enerson requested to hide it temporary
    <div class="homeContainer pt-4">
        <div class="row">
            <div class="col-12 text-center secTitle">Trusted partners</div>
            <div class="imgDesc text-center">Lorem ipsum dolor sit amet consectetur adipisicing elit. Eaque ex magni, ipsa nihil accusamus laborum blanditiis quibusdam? Dolor dolores ut fuga asperiores. Ea ipsam et hic qui laborum quo eius.</div>
        </div>
    </div>
    
    <div class="row mt-4">
        <div class="col-12 col-lg-2 d-grid">
            <div class="logoBox border">
                <table style="height: 100%;" align="center">
                    <tbody>
                        <tr>
                            <td class="align-middle"><img alt="Vue logo" src="../assets/home/logo_genusis.png" class="img-fluid"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="col-12 col-lg-2 d-grid">
            <div class="logoBox border">
                <table style="height: 100%;" align="center">
                    <tbody>
                        <tr>
                            <td class="align-middle"><img alt="Vue logo" src="../assets/home/logo_ac.jpeg" class="img-fluid"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="col-12 col-lg-2 d-grid">
            <div class="logoBox border">
                <table style="height: 100%;" align="center">
                    <tbody>
                        <tr>
                            <td class="align-middle"><img alt="Vue logo" src="../assets/home/logo_algae.jpeg" class="img-fluid"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="col-12 col-lg-2 d-grid">
            <div class="logoBox border">
                <table style="height: 100%;" align="center">
                    <tbody>
                        <tr>
                            <td class="align-middle"><img alt="Vue logo" src="../assets/home/logo_ggv.jpeg" class="img-fluid"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="col-12 col-lg-2 d-grid">
            <div class="logoBox border">
                <table style="height: 100%;" align="center">
                    <tbody>
                        <tr>
                            <td class="align-middle"><img alt="Vue logo" src="../assets/home/logo_thegigabit.jpeg" class="img-fluid"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div> -->

    <div class="row">
        <div class="col-12 footer">
            <Footer />
        </div>
    </div>

    <!-- Enerson requested to hide floating button temporary
    <span id="floatContainer" class="shadow-sm">
        <fa icon="phone" id="floatButton" />
    </span> -->
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->

    <!-- Modal: TalkToUs --> 
    <div class="modal fade" id="mdlTalk" ref="mdlTalk" tabindex="-1" aria-labelledby="AddNote" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered text-dark">
            <div class="modal-content">
                <div class="modal-header border-0">
                    <h5 class="modal-title" id="exampleModalLabel"> Talk to us</h5>
                    <button type="button" class="btn-close"  data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <table class="table table-borderless">
                                <tbody>
                                    <tr>
                                        <td><input type="text" class="form-control" v-model="reqName" placeholder="Name *" :disabled="(validSession === true && getDisplayName !== null && getDisplayName !== undefined && getDisplayName !== '') ? true : false"></td>
                                    </tr>
                                    <tr>
                                        <td><input type="text" class="form-control" v-model="reqEmail" placeholder="Email *" :disabled="validSession === true ? true : false"></td>
                                    </tr>
                                    <tr>
                                        <td><textarea class="form-control" v-model="reqRemark" placeholder="Request *"></textarea></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer" style="justify-content: space-between">
                    <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
                        <i class="fa-solid fa-xmark me-2"></i>Cancel
                    </button>
                    <button class="btn btn-secondary me-2" @click="talkToUs" data-bs-dismiss="modal" >
                        <i class="fa-solid fa-paper-plane-top me-2"></i>Submit
                    </button>
                </div>
            </div><!-- modal-content -->
        </div><!-- modal-dialog -->
    </div><!-- Modal End-->
  
</template>

<script>
import { ref, inject, onMounted, watch } from 'vue'
import TopNavigation from '@/components/TopNavigation.vue'
import Footer from '@/components/Footer.vue'
import Alert from '@/components/Alert.vue'
import { useRouter, useRoute } from 'vue-router'
import Popper from 'vue3-popper'
import funcs from '@/functions/funcs'
import Avatar from '@/components/Avatar.vue'
// import { useStore } from '@/stores/store'

export default {
  name: 'Home',
  components: { Alert, TopNavigation, Footer, Popper, Avatar },
  setup() {
        const axios = inject('axios')
        const alert = ref([])
        const route = useRoute()
        const router = useRouter()
        const func = funcs

        // const { getDisplayName, getAvatar, getUserIsVerified, getUserId, getUserLastLogin } = useStore()
        const store = inject('store')
        const getUserId = store.getUserId
        const getDisplayName = store.getDisplayName
        const getAvatar = store.getAvatar
        const getUserIsVerified = store.getUserIsVerified
        const getUserLastLogin = store.getUserLastLogin
        const getCurrency = store.getCurrency
        const getPackage = store.getPackage


        const docId = ref(null)
        // const docId = ref('_4gP53zir7kHGaUG6Iams')
        const showDetail = ref(false)
        const doc = ref({})
        const isCreator = ref(false)
        const isPrivate = ref(false) 
        const isFinance = ref(false)
        const signees = ref([])
        const viewers = ref([])
        const validSession = ref(false)
        const payInYear = ref(false)

        const reqName = ref(null)
        const reqEmail = ref(null)
        const reqRemark = ref(null)

        const payOpt = ref('yearly')    // monthly/yearly
        // const exclusiveImg = ref(null)
        const showMore = ref(false)
        const showMoreWhy = ref(false)
        
        const arrPlan = ref([])

        watch([payOpt], () => {
            console.info('watch payOpt', payOpt.value)
            getPlanList()
        })

        const goFeature = () => {
            window.location.href = window.location.origin + '/feature'
        }

        const goTrial = () => {
            window.location.href = 'https://app.signon.my/auth/signup'
        }

        const goVerifyDoc = () => {
            window.location.href = 'https://app.signon.my/doc/verify'
        }

        const searchDocById = async () => {
            if (docId.value === null || docId.value === '') {
                alert.value.push({
                    class: "danger",
                    title: "ERROR",
                    message: 'Please enter document ID.'
                })

            } else {
                await axios.get( '/signon/signee/document/' + docId.value)
                    .then((res) => {
                        // console.info('searchDocById ', JSON.stringify(res.data.data))
                        console.info('searchDocById signees', JSON.stringify(res.data.data.signees))
                        // console.info('searchDocById signee', JSON.stringify(res.data.data.signee))

                        if (res.data.status === 1) {
                        showDetail.value = true
                        doc.value = res.data.data
                        isPrivate.value = res.data.data.isPrivate

                        if (res.data.data.signee.privileges && res.data.data.signee.privileges.includes('creator') !== undefined) {
                            isCreator.value = res.data.data.signee.privileges.includes('creator')
                        }

                        if (res.data.data.signees) {
                            res.data.data.signees.forEach((item, idx) => {
                                //    console.info('item', JSON.stringify(item))
                                if (item.privileges) {
                                    console.info('-- privileges', JSON.stringify(item))
                                    //    console.info('item', item.privileges)
                                    if (item.privileges.includes('signee')) {
                                        signees.value.push(item)
                                    }
                                    if (item.privileges.includes('viewer')) {
                                        viewers.value.push(item)
                                    }
                                } else {
                                    console.info('x privileges', JSON.stringify(item))
                                    viewers.value.push(item)
                                }
                            })

                            // console.info('signees', JSON.stringify(signees.value))
                            // console.info('viewers', JSON.stringify(viewers.value))
                        }
                        } 
                    })
                    .catch((error) => {
                        if (error.status === 'record_not_found') {
                            alert.value.push({
                                class: "danger",
                                title: "ERROR",
                                message: 'Record not found. (' + error.code + ')'
                            })

                        } else {
                            console.log('FAILURE', error)
                            alert.value.push({
                                class: "danger",
                                title: "ERROR",
                                message: func.convError(error)
                            })
                        }
                    })
            }
        }

        const updIsPrivate = (val) => {
            
            const p = {
                isPrivate: val
            }

            axios.put( '/signon/' + doc.value.projectId + '/' + docId.value, p)
                .then((res) => {

                    if (res.data.status === 1) {
                        isPrivate.value = val // after update axios success

                        alert.value.push({
                            class: "success",
                            title: "SUCCESS",
                            message: "Document is updated to " + (val ? "private." : "public.")
                        })
                    } 
                })
                .catch((error) => {
                    console.log('FAILURE', error)
                    alert.value.push({
                        class: "danger",
                        title: "ERROR",
                        message: func.convError(error)
                    })
                })
        }

        const closeAlert = (index) => {
            alert.value.splice(index, 1)
        }

        const getPlanList = async () => {
            const p = {
                currency: getCurrency.value ,
                subscription: payOpt.value === 'yearly' ? 'ANNUM' : 'MONTHLY'
            }

            // console.info('getPlanList', payOpt.value, getCurrency.value, JSON.stringify(p))
            axios.post('/plan/list', p)
                .then((res) => {
                    
                    if (res.data.status === 1001) {
                        router.push({ path: '/auth/login', query: {e: 'ns'} })

                    } else if (res.data.status === 1) {
                        // console.info('getPlanList arrPlan', JSON.stringify(res.data.data))
                        const arrPlanTmp = res.data.data
                        arrPlan.value = arrPlanTmp.sort((a, b) => a.chargePerUser - b.chargePerUser)

                    } else {

                        if (res && res.data !== null && res.data !== undefined) {
                            alert.value.push({
                                class: "danger",
                                title: "ERROR",
                                message: func.getError(res.data)
                            })

                        }

                    }

                })
                .catch((error) => {
                    console.info('error', error)
                    func.addLog('static - plan', 'getPlanList - catch', error.code + ' | ' +error.status + ' | ' + error.message + ' | ' + error.data +  ' | ' + error)

                })
        }

        const talkToUs = () => {

            if (reqEmail.value === null || reqEmail.value === undefined || reqEmail.value === '') {
                alert.value.push({
                    class: "danger",
                    title: "ERROR",
                    message: "Please enter your email."
                })

            } else if (reqName.value === null || reqName.value === undefined || reqName.value === '') {
                alert.value.push({
                    class: "danger",
                    title: "ERROR",
                    message: "Please enter your name."
                })

            } else if (reqRemark.value === null || reqRemark.value === undefined || reqRemark.value === '') {
                alert.value.push({
                    class: "danger",
                    title: "ERROR",
                    message: "Please enter your request."
                })

            } else {

                const p = {
                    email: reqEmail.value,
                    displayName: reqName.value,
                    subject: 'Enterprise - Talk to us',
                    message: reqRemark.value
                }

                axios.post( '/ticket', p)
                    .then((res) => {
                        // console.info('submit - res', res)
                        if (res.data.status === 1) {
                            alert.value.push({
                                class: "success",
                                title: "SUCCESS",
                                message: "Your request has been submitted. We will get back to you as soon as possible."
                            })

                            reqRemark.value = null

                        } else {
                            func.addLog('static - pricing', 'talkToUs', res)
                            if (res && res.data !== null && res.data !== undefined) {
                                
                                alert.value.push({
                                    class: "danger",
                                    title: "ERROR",
                                    message: func.getError(res.data)
                                })
                            }
                        }

                    })
                    .catch((error) => {
                        func.addLog('static - pricing', 'talkToUs - catch', error.code + ' | ' +error.status + ' | ' + error.message + ' | ' + error.data +  ' | ' + error)
                        
                    })
            }
        }

        const chkSession = async () => {
            try {
                const response = await axios.get('/auth/signin/session')
                // console.info('TOPNav chkSession', JSON.stringify(response.data.data))
                if( response.data.status === 1) {
                    validSession.value = true
                   
                } else {
                    validSession.value = false
                }

            } catch (error) {
                validSession.value = false
            }
        }

        /* computed: {
            exclusiveImg() {
                return {
                    backgroundImage: `url${require('../assets/home/rocket.jpg')}`
                }
            }
        } */

        onMounted(async () => {

            // console.info('HOME onMounted', config.hostname)
            func.clearPrevLocalStorage()
            chkSession()

            // First time login
            if (route.query.fl === true || route.query.fl === 'true') {
                alert.value.push({
                    class: "success",
                    title: "SUCCESS",
                    message: "Welcome to SignOn."
                })
            }

            // Not first time login
            if (route.query.fl === false || route.query.fl === 'false') {
                if (route.query.l) { 
                    alert.value.push({
                        class: "success",
                        title: "SUCCESS",
                        message: "Welcome back. Last login " + func.getDateTimeDiff(func.convDateTimeFormat(route.query.l), new Date()) + ", last active " + func.getDateTimeDiff(func.convDateTimeFormat(route.query.a), new Date()) + "."
                    })
                }
            }

            if (func.isEmptyObject(localStorage.getItem('entity')) === false) {
                let objLSEntity = func.decodeStrToJsonSimple(localStorage.getItem('entity'))
               
                if (objLSEntity.isFinance === true) {
                    isFinance.value = true
                } else {
                    isFinance.value = false
                }
            
            }

            if (getPackage.value !== null) {
                if (getUserId.value !== null && getUserId.value !== undefined) {
                    reqEmail.value = getUserId.value
                }

                if (getDisplayName.value !== null && getDisplayName.value !== undefined) {
                    reqName.value = getDisplayName.value
                }
            }

            getPlanList()


           /*  exclusiveImg.value = computed({
                backgroundImage: `url${require('../assets/home/rocket.jpg')}`
            }) */
        })

        return { 
            alert, closeAlert, route, router, func, docId, searchDocById, showDetail, doc, 
            signees, viewers, validSession, isCreator, isPrivate, updIsPrivate,
            getDisplayName, getAvatar, getUserIsVerified, getUserId, getUserLastLogin, getCurrency, getPackage,
            goVerifyDoc, goTrial, payInYear, payOpt, showMore, showMoreWhy, arrPlan, 
            /* exclusiveImg */ reqName, reqEmail, reqRemark, isFinance, talkToUs, goFeature
        }
    }
}
</script>


<style>
.howBoxContainer {
    padding: 5px;
    margin-bottom: 10px;
}

.howBox {
    padding: 1.5rem 1.2rem;
    border-radius: 15px;
}

.howBoxImgSec {
    height: 50px;
    text-align: center;
}

.howTitle {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.43;
    color: #6E777E;
    font-family: "Inter-Medium", sans-serif;
}

.whyBox {
    padding: 1.5rem 1.2rem;
    border-radius: 15px;
    min-height: 225px;
}

.whyTitle {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.43;
    color: #6E777E;
    font-family: "Inter-Medium", sans-serif;
}

.whyBoxImgSec {
    height: 100px;
    text-align: center;
    margin-bottom: 25px;
}

.btnVerify:hover {
    color: #fff
}

#mainSlider .carousel-control-prev-icon,
#mainSlider .carousel-control-next-icon {
    filter: grayscale(100%) brightness(0.6);
    background-color: transparent !important;
    position: absolute;
    z-index: 2;
}

#mainSlider .carousel-item {
    /* height: 650px; */
    height: 750px;
}

.feature-icon {
    font-size: 8rem;
    margin-bottom: 1rem;
}

.main-title {
    font-size: 4rem;
    font-weight: 700;
    text-shadow: 0 4px 8px rgba(0,0,0,0.4);
    position: absolute;
    z-index: 1;
    top: 15%;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    width: 100%;
    color: #fff; 
}

.main-desc {
    font-size: 1.5rem;
    font-weight: 400;
    opacity: 0.8;
    line-height: 1.5;
    position: absolute;
    z-index: 1;
    top: 32%;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    width: 100%;
    padding-left: 10%;
    padding-right: 10%;
    color: #fff; 
}

.main-btn {
    position: absolute;
    z-index: 1;
    bottom: 15%;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    width: 100%;
}

.feature-title {
    font-size: 4rem;
    font-weight: 700;
    text-shadow: 0 4px 8px rgba(0,0,0,0.4);
    width: 100%;
    bottom: 25%;
    text-align: center;
}

.feature-desc {
    font-size: 1.3rem;
    font-weight: 400;
    opacity: 0.8;
    line-height: 1.4;
    width: 100%;
    bottom: 32%;
    text-align: center;
}

@media (max-width: 1600px) {
    #mainSlider .carousel-item {
        max-height: 670px;
        /* border: 2px dashed green; */
    }
}

@media (max-width: 1400px) {
    #mainSlider .carousel-item {
        /* max-height: 500px; */
        max-height: 560px;
        /* border: 2px solid red; */
    }
}

@media (max-width: 1200px) {
    #mainSlider .carousel-item {
        /* max-height: 400px; */
        max-height: 460px;
        /* border: 2px dashed blue; */
    }

     .main-title {
        font-size: 2.5rem;
        font-weight: 700;
        text-shadow: 0 4px 8px rgba(0,0,0,0.4);
        position: absolute;
        z-index: 1;
        top: 10%;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        width: 100%;
        padding-left: 5%;
        padding-right: 5%;
        color: #fff; 
    }

     .main-desc {
        font-size: 1.2rem;
        font-weight: 400;
        opacity: 0.8;
        line-height: 1.4;
        position: absolute;
        z-index: 1;
        top: 35%;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        width: 100%;
        padding-left: 10%;
        padding-right: 10%;
        color: #fff; 
    }

    .main-btn {
        position: absolute;
        z-index: 1;
        top: 70%;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        text-align: center;
        height: 20%;
    }

    .feature-title {
        font-size: 3rem;
        font-weight: 700;
        text-shadow: 0 4px 8px rgba(0,0,0,0.4);
        width: 100%;
        padding-left: 5%;
        padding-right: 5%;
        padding-top: 20px;
        text-align: center; 
    }

    .feature-desc {
        font-size: 1.2rem;
        font-weight: 400;
        opacity: 0.8;
        line-height: 1.4;
        width: 100%;
        padding-left: 5%;
        padding-right: 5%;
        padding-top: 20px;
        text-align: center;
    }
}

@media (max-width: 992px) {
    #mainSlider .carousel-item {
        max-height: 650px;
    }

    .main-title {
        font-size: 2.5rem;
        font-weight: 700;
        text-shadow: 0 4px 8px rgba(0,0,0,0.4);
        position: absolute;
        z-index: 1;
        top: 10%;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        width: 100%;
        padding-left: 5%;
        padding-right: 5%;
        color: #fff; 
    }

     .main-desc {
        font-size: 1.2rem;
        font-weight: 400;
        opacity: 0.8;
        line-height: 1.5;
        position: absolute;
        z-index: 1;
        top: 35%;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        width: 100%;
        padding-left: 15%;
        padding-right: 15%;
        color: #fff; 
    }

    .main-btn {
        position: absolute;
        z-index: 1;
        top: 75%;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        text-align: center;
        height: 20%;
    }

    .feature-title {
        font-size: 3rem;
        font-weight: 700;
        text-shadow: 0 4px 8px rgba(0,0,0,0.4);
        width: 100%;
        padding-left: 5%;
        padding-right: 5%;
        padding-top: 20px;
        text-align: center; 
    }

    .feature-desc {
        font-size: 1.2rem;
        font-weight: 400;
        opacity: 0.8;
        line-height: 1.4;
        width: 100%;
        padding-left: 5%;
        padding-right: 5%;
        padding-top: 20px;
        text-align: center;
    }
}

@media (max-width: 768px) {
    #mainSlider .carousel-item {
        height: 550px;
    }

    .main-title {
        font-size: 2.5rem;
        font-weight: 700;
        text-shadow: 0 4px 8px rgba(0,0,0,0.4);
        position: absolute;
        z-index: 1;
        top: 10%;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        width: 100%;
        padding-left: 5%;
        padding-right: 5%;
        color: #fff; 
    }

    .main-desc {
        font-size: 1.2rem;
        font-weight: 400;
        opacity: 0.8;
        line-height: 1.5;
        position: absolute;
        z-index: 1;
        top: 40%;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        width: 100%;
        padding-left: 15%;
        padding-right: 15%;
        color: #fff; 
    }

    .main-btn {
        position: absolute;
        z-index: 1;
        top: 70%;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        text-align: center;
        height: 20%;
    }

    .feature-title {
        font-size: 2.5rem;
        font-weight: 700;
        text-shadow: 0 4px 8px rgba(0,0,0,0.4);
        width: 100%;
        padding-left: 5%;
        padding-right: 5%;
        padding-top: 20px;
        text-align: center; 
    }

    .feature-desc {
        font-size: 1.1rem;
        font-weight: 400;
        opacity: 0.8;
        line-height: 1.4;
        width: 100%;
        padding-left: 5%;
        padding-right: 5%;
        padding-top: 20px;
        text-align: center;
    }
}

@media (max-width: 575.98px) {

    #mainSlider .carousel-item {
        height: 390px;
    }

    .main-title {
        font-size: 2rem;
        font-weight: 700;
        text-shadow: 0 4px 8px rgba(0,0,0,0.4);
        position: absolute;
        z-index: 1;
        top: 5%;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        width: 100%;
        padding-left: 5%;
        padding-right: 5%;
        color: #fff; 
    }

    .main-desc {
        font-size: 1rem;
        font-weight: 400;
        opacity: 0.8;
        line-height: 1.5;
        position: absolute;
        z-index: 1;
        top: 30%;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        width: 100%;
        padding-left: 10%;
        padding-right: 10%;
        color: #fff; 
    }

    .main-btn {
        position: absolute;
        z-index: 1;
        top: 70%;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        text-align: center;
        height: 20%;
    }

    .feature-title {
        font-size: 2rem;
        font-weight: 700;
        text-shadow: 0 4px 8px rgba(0,0,0,0.4);
        width: 100%;
        padding-left: 5%;
        padding-right: 5%;
        padding-top: 20px;
        text-align: center; 
    }

    .feature-desc {
        font-size: 1rem;
        font-weight: 400;
        opacity: 0.8;
        line-height: 1.4;
        width: 100%;
        padding-left: 5%;
        padding-right: 5%;
        padding-top: 20px;
        text-align: center;
    }

    .feature-icon {
        font-size: 5rem;
        margin-bottom: 1rem;
    }
}

#planSm .carousel-control-prev, #planSm .carousel-control-next {
    border-radius: 50%;
    width: 3rem;
    height: 3rem;
    margin: 1rem;
    /* border: 1px solid #6E777E; */
    margin-top: 88px;
}

#planSm .carousel-control-next-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512' fill='%23666666'%3e%3cpath d='M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z'/%3e%3c/svg%3e");
}

#planSm .carousel-control-prev-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512' fill='%23666666'%3e%3cpath d='M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z'/%3e%3c/svg%3e");
}

.exclusiveImg {
    height: 300px;
    border-radius: 10px 0px 0px 10px;
    background: url('../assets/home/rocket.jpg') no-repeat center;
}

.whoWeAreImg {
    height: 400px;
    border-radius: 10px 0px 0px 10px;
    background: url('../assets/home/kl_map.webp') no-repeat center;
}

#floatContainer {
    display: flex; 
    flex-direction: column;  
    justify-content: flex-end;  
    align-items: center;  
    user-select: none;  
    position: fixed;  
    bottom: 30px; 
    right: 30px;
    padding: 18px;
    /* background-color: #53BDEB; */
    border-radius: 35px;
    
  background-color: #212529;
  border-color: #212529;
}

#floatContainer:hover {
    /* background-color: #53B1D9; */
    background-color: #0C1116;
    cursor: pointer;
}

#floatButton {
    font-size: 26px;
    color: #ffffff;
}

.greyContainer {
  margin-top: 30px;
  padding-top: 50px;
  padding-bottom: 50px;
  background-color: var(--navbar-light);
}


.greyContent {
    width: 75%; 
    margin: 0px auto; 
    font-size: 17px;
    font-family: "Inter-Medium", sans-serif;
    font-weight: 400;
    line-height: 1.43;
}

.homeContainer {
  width: 75%; 
  margin: 55px auto 0px auto;
}

.homeBox {
  border-radius: 10px;
  padding: 25px;
  margin-bottom: 25px;
  margin-left: 2px;
  margin-right: 2px;
  color: #6E777E;
}

.homeBlueBox {
  border-radius: 10px;
  padding: 25px;
  margin-bottom: 25px;
  margin-left: 2px;
  margin-right: 2px;
  background-color: #53BDEB;
  color: var(--bgcolor-body-color);
}

.imgTitle {
    font-size: 64px;
    font-weight: bold;
    color: #6E777E;
    font-family: "TT-Firs-Neue-Demi-Bold", sans-serif;
    font-weight: 600;
    line-height: 74px;
    letter-spacing: -0.02em;
    margin-bottom: 28px;
}

.imgDesc {
    font-size: 22px;
    color: #6E777E;
    opacity: 0.6;
    font-family: "Inter-Medium", sans-serif;
    font-weight: 400;
    line-height: 1.43;
    margin-bottom: 28px;
}

.secTitle {
    font-size: 4rem;
    font-weight: bold;
    color: #6E777E;
    font-family: "TT-Firs-Neue-Demi-Bold", sans-serif;
    font-weight: 600;
    line-height: 74px;
    letter-spacing: -0.02em;
    padding-top: 32px;
    padding-bottom: 38px;
}

.secTitleNarrow {
    font-size: 4rem;
    font-weight: bold;
    color: #6E777E;
    font-family: "TT-Firs-Neue-Demi-Bold", sans-serif;
    font-weight: 600;
    line-height: 74px;
    letter-spacing: -0.02em;
    padding-top: 32px;
    padding-bottom: 22px;
}

.boxContent {
    margin-left: 20px;
    margin-right: 20px;
}

.boxTitle {
    font-size: 50px;
    font-weight: bold;
    font-family: "TT-Firs-Neue-Demi-Bold", sans-serif;
    line-height: 74px;
    letter-spacing: -0.02em;
    color: #6E777E;
}

.boxDesc {
    font-size: 16px;
    font-family: "Inter-Medium", sans-serif;
    font-weight: 400;
    line-height: 1.43;
    color: #8F9093;
}

.boxButton {
    margin-top: 40px;
    margin-bottom: 0px;
    padding-bottom: 0px;
    height: 50px;
}

.boxTable {
    font-size: 17px;
    font-family: Inter,sans-serif;
    font-weight: 500;
    line-height: 1.5;
    color: #8F9093;
    height: 80px;
}

@media (max-width: 1200px) {
    .secTitle {
        font-size: 3rem;
        font-weight: bold;
        color: #6E777E;
        font-family: "TT-Firs-Neue-Demi-Bold", sans-serif;
        font-weight: 600;
        line-height: 74px;
        letter-spacing: -0.02em;
        padding-bottom: 30px;
        padding-top: 10px;
    }

    .secTitleNarrow {
        font-size: 3rem;
        font-weight: bold;
        color: #6E777E;
        font-family: "TT-Firs-Neue-Demi-Bold", sans-serif;
        font-weight: 600;
        line-height: 74px;
        letter-spacing: -0.02em;
        padding-bottom: 15px;
        padding-top: 10px;
    }
}
@media (max-width: 768px) {
    .secTitle {
        font-size: 2.5rem;
        font-weight: bold;
        color: #6E777E;
        font-family: "TT-Firs-Neue-Demi-Bold", sans-serif;
        font-weight: 600;
        line-height: 74px;
        letter-spacing: -0.02em;
        padding-bottom: 25px;
        padding-top: 5px;
    }

    .secTitleNarrow {
        font-size: 2.5rem;
        font-weight: bold;
        color: #6E777E;
        font-family: "TT-Firs-Neue-Demi-Bold", sans-serif;
        font-weight: 600;
        line-height: 74px;
        letter-spacing: -0.02em;
        padding-bottom: 10px;
        padding-top: 5px;
    }
}
@media (max-width: 575.98px) {
    .secTitle {
        font-size: 2rem;
        font-weight: bold;
        color: #6E777E;
        font-family: "TT-Firs-Neue-Demi-Bold", sans-serif;
        font-weight: 600;
        line-height: 40px;
        letter-spacing: -0.02em;
        padding-bottom: 32px;
        padding-top: 20px;
    }

    .secTitleNarrow {
        font-size: 2rem;
        font-weight: bold;
        color: #6E777E;
        font-family: "TT-Firs-Neue-Demi-Bold", sans-serif;
        font-weight: 600;
        line-height: 40px;
        letter-spacing: -0.02em;
        padding-bottom: 15px;
        padding-top: 18px;
    }
}

.lblLogo {
    font-size: 18px;
    color: var(--section-title);
    font-family: "Inter-Bold", sans-serif;
}

.lblStep {
    font-size: 17px;
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 8px;
    color: #53BDEB;
    font-family: "Inter-Medium", sans-serif;
    font-size: 17px;

}

.lblStepTitle {
    font-size: 34px;
    font-weight: 400;
    line-height: 1.43;
    color: var(--section-title);
    font-family: "Inter-Medium", sans-serif;
    margin-bottom: 10px;
}

.lblStepDesc {
    color: var(--section-title);
    margin: 0;
    font-size: 17px;
    font-family: "Inter-Medium", sans-serif;
    font-weight: 400;
    line-height: 1.43;
    height: 180px;
}

.lblStepSubTitle {
    font-size: 24px;
    font-weight: 600;
    line-height: 1.43;
    color: #6E777E;
    font-family: "Inter-Medium", sans-serif;
    /* margin-bottom: 10px; */
}

.lblStepSubDesc {
    color: #6E777E;
    margin: 0;
    font-size: 17px;
    font-family: "Inter-Medium", sans-serif;
    font-weight: 400;
    line-height: 1.43;
}

.numberCicle {
    width: 15px;
    height: 15px;
    padding: 10px;
    border-radius: 20px;
    border: 1px solid var(--bs-primary);
    font-size: 18px;
    font-weight: 600;
}

.boxFlow {
    border-radius: 15px;
    color: #6E777E;
    font-size: 17px;
    font-family: "Inter-Medium", sans-serif;
    font-weight: 400;
    line-height: 1.43;
    /* background-color: var(--navbar-light); */
    background-color: var(--form-control-grey);
}

.boxTextFlow {
    padding-left: 10px;
    padding-right: 10px;
}

.faqTitle {
    color: var(--text-grey-link);
}

.footer {
    margin-top: 80px;
    margin-bottom: 0px;
    padding: 0px 0px 0px 0px;
    background-color: var(--navbar-light);
    border-top-color: var(--toolbar-hr);
}

.logoBox {
  border-radius: 10px;
  padding-left: 25px;
  padding-right: 25px;
  margin-bottom: 25px;
  color: #1F2226;
  height: 105px;
  text-align: center;
  vertical-align: middle;
}

.logoBox > table > tbody > tr > td > img {
    max-height: 80px;
}


.step-number .bg-gray-1 {
    margin-right: 10px;
    /* border: 1px solid #def7f0; */
    /* border: 1px solid var(--bs-primary);
     */
     border: 1px solid red;
}
.step-number {
    position: relative;
    display: flex;
    overflow: hidden;
    width: 40px;
    height: 40px;
    padding: 10px;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    border-radius: 9999px;
    /* color: #160647; */
    color: var(--text-islink-hover);
    line-height: 1;
    font-weight: 600;
    text-align: center;
    letter-spacing: 0;
    text-transform: uppercase;
}

.bg-gray-1 {
    /* background-color: #f8fcfb; */
    background-color: var(--accordion-bg);
    /* border: 1px solid #DDF2F8; */
    border: 1px solid var(--number-circle);
}

.planBox {
    border-radius: 10px;
    /* padding: 0px 22px 25px 22px; */
    padding: 0px;
    margin-bottom: 25px;
    margin-left: 2px;
    margin-right: 2px;
    color: #6E777E;
}

.planBoxContainerSm {
    padding: 0px 25px;
}

.boxTitleSm {
    font-size: 30px;
    font-weight: bold;
    font-family: "TT-Firs-Neue-Demi-Bold", sans-serif;
    line-height: 74px;
    letter-spacing: -0.02em;
    color: #6E777E;
}


.planBoxReco {
    border-radius: 10px;
    /* padding: 25px 22px; */
    padding: 0px;
    margin-bottom: 25px;
    margin-left: 2px;
    margin-right: 2px;
    color: #6E777E;
    border: 1px solid var(--bs-primary);
}

.boxButton {
    /* margin-top: 50px; */
    margin-top: 10px;
    margin-left: 20px;
    margin-right: 20px;
    /* margin-bottom: 0px; */
    /* padding-bottom: 0px; */
    height: 70px;
}

.planBoxButtonWithTrial {
    margin-top: 10px;
    margin-bottom: 0px;
    padding-bottom: 0px;
    height: 50px;
}

.planHeader {
    background-color: #f8f9fa;
    padding: 5px 25px;
    margin-bottom: 15px;
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
    text-align: center;
}

.planHeaderReco {
    background-color: #53BDEB;
    padding: 5px 25px;
    margin-bottom: 15px;
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
    text-align: center;
}

.planBoxTitle {
    font-size: 50px;
    font-weight: bold;
    font-family: "TT-Firs-Neue-Demi-Bold", sans-serif;
    line-height: 74px;
    letter-spacing: -0.02em;
    color: #6E777E;
}

.iconBlue {
    color: #53BDEB;
}

@media (max-width: 500px) {

    .greyContent {
        width: 100%;
        padding-left: 10px;
        padding-right: 10px;
    }

    .homeContainer {
      width: 100%;
      margin: 40px auto 40px auto;
      /* border: 1px solid green; */
    }

    .imgTitle {
        font-size: 39px;
        line-height: 41px;
        letter-spacing: -0.01em;
    }

    .imgDesc, .boxDesc {
        font-size: 20px;
        font-family: "Inter-Medium", sans-serif;
        line-height: 1.5;
    }

    .footer {
        margin-top: 40px;
        padding: 40px 0px;
    }

    .lblStepSubTitle {
        font-size: 18px;
        font-weight: 600;
        line-height: 1.43;
        color: #6E777E;
        font-family: "Inter-Medium", sans-serif;
        margin-bottom: 10px;
            padding-top: 5px;
    }

    .lblStepSubDesc {
        color: #6E777E;
        margin: 0 8px;
        font-size: 18px;
        font-family: "Inter-Medium", sans-serif;
        font-weight: 400;
        line-height: 1.43;
    }

    .boxTextFlow {
        padding-left: 0px;
        padding-right: 0px;
    }
}
</style>
